<template>
  <div class=" mx-1 flex-grow-1 d-flex flex-column" style="width: 100%;">
    <v-dialog
      v-model="requestDeviceMotion"
      width="auto"
    >
      <v-card
        max-width="400"
        prepend-icon="mdi-update"
      >
        <v-card-title>
          Orientation by mobile motion
        </v-card-title>
        <v-card-text>
          The 3D model can be controlled on mobile devices using the motion sensors. It is recommended to switch off the automatic rotation. Also, authorization may be required for this.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="grantAccessToMobileMotion"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-radio-group
      :attach="'#' +elementID"
      class="justify-center mx-5"
      row
      center-affix label="Camera"
      v-model="camera"
    >
      <v-radio
        v-for="(item_value, item_name, item_key) in cameraDic"
        :key="item_key"
        :label="getWallName(item_value.name)" :value=item_value
      >
      </v-radio>
    </v-radio-group>
    <div class="content-wrapper" style="height: fit-content;">

      <v-alert
        v-if="isShowingInfo"
        class="overlay-alert"
        color="grey"
        dense
        border="top"
        icon="mdi-info"
        dismissible
      >
        Navigate by clicking on 3D-Model. Move with keys "w", "a", "s", "d". {{ info }}
      </v-alert>

      <!-- rest of your content -->

    </div>
    <v-dialog v-model="progress.visible" persistent width="300">
      <v-card>
        <v-card-title>Walls are being prepared...</v-card-title>
        <v-card-text>
          <v-progress-linear :value="(progress.current / progress.total) * 100" color="primary" height="10" />
          <div style="margin-top: 10px">Process Wall: {{ progress.currentWall + " - " + progress.step }}</div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-row class="fill-height pa-0">
      <v-col
        class="d-flex align-stretch flex-column"
        v-if="showTree"
        :cols="renderVRMode ? 8 : 4"  style="height: 100%;"
      >
        <Cave3DModelFilterPanel ref="Cave3DModelFilterPanel1" :renderVRMode="renderVRMode" :treeID="elementID + '-tree1-iconographyID-'+item.iconographyID" :locationFacets="locationFacets" :filteredIcoAnnos="filteredIcoAnnos" :annoPrCount="annoPrCount" :changedLocationInput="changedLocationInput" :prepLocationAggs="prepLocationAggs" :updateicoSelectedParent="updateicoSelectedParent" :annoPreSelected="icoSelected" :setLocations="setLocations" :locationsPreSet="selectedLocations" hoveredIcos="hoveredIcos" />
      </v-col>
      <v-col :cols="showTree ? 8 : 12" style="min-height: 0;">
      <div v-resize="onWindowResize" :id="elementID" ref="cave3DModel" :style="'display:flex!important;flex-direction:column;height: 100%;'">
        <v-row ref="butonRow" class="d-flex justify-space-around mt-1 mb-n8" no-gutters height="6%" id="controls" :attach="'#' +elementID" style='position: relative;z-index: 4;'>
          <v-btn
          v-if="isVR"
          class="pa-1 text-xs-center"
          style="text-align: center;"
          small
          id="buttonVR"
          :attach="'#' +elementID"
          color="primary"
          dark
          @click="switchToVR">
            Enable VR
          </v-btn>
          <v-btn
          v-if="isMobile()"
          class="pa-1 text-xs-center"
          style="text-align: center;"
          small
          id="button4"
          :attach="'#' +elementID"
          color="primary"
          dark
          @click="enablePointControllsMobile">
            {{getLabelEnablePointControllsMobile()}}
          </v-btn>
          <v-bottom-sheet
            v-if="(isMobile()  || fullScreen) && item.caveID"
            style="text-align: center;"
            class="pa-1 filter-bottom-sheet"
            v-model="sheetTree"
            inset
            :fullscreen="false"
            hide-overlay
            :attach="'#' +elementID"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                class="text-xs-center px-0"
                :attach="'#' +elementID"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on">
                {{ getLabelOpenAnnotations() }}
              </v-btn>
            </template>
            <v-sheet
              :attach="'#' +elementID"
              class="text-center sheet-content"
            >
            <v-card class="sheet-card">
              <v-btn
                small
                class="text-xs-center px-0 mt-3"
                :attach="'#' +elementID"
                color="primary"
                dark
                @click="sheetTree = false">
                Close
              </v-btn>
              <div class="tree-scroll">
              <Cave3DModelFilterPanel  ref="Cave3DModelFilterPanel2" :treeID="elementID + '-tree1-iconographyID-'+item.iconographyID" :locationFacets="locationFacets" :icoAnnos="icoAnnos" :annoPrCount="annoPrCount" :changedLocationInput="changedLocationInput" :prepLocationAggs="prepLocationAggs" :updateicoSelectedParent="updateicoSelectedParent" :annoPreSelected="icoSelected" :setLocations="setLocations" :locationsPreSet="selectedLocations"/>
              </div>
            </v-card>
            </v-sheet>
          </v-bottom-sheet>
          <v-bottom-sheet
            style="text-align: center;"
            class="text-xs-center px-0"
            v-model="sheetLegend"
            inset
            hide-overlay
            :attach="'#' +elementID"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                class="text-xs-center"
                :attach="'#' +elementID"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on">
                {{getLegendLabel()}}
              </v-btn>
            </template>
            <v-sheet
              :attach="'#' +elementID"
              class="text-center"
              height="100%"
              style="overflow-y: scroll;"
            >
              <v-card-title class="pb-1 mb-2 mx-3" style="border-bottom: 1px dashed #666;">Colour code for the register system in the 3D-Model</v-card-title>
                <v-row class="mb-1">
                  <v-col cols="1">
                    <v-card class="color-box pa-3 align-stretch" color="rgba(200, 0, 0,0.8)">
                    </v-card>
                  </v-col>
                  <v-col class="text-left">
                    Segment is lost.
                  </v-col>
                </v-row>
                <v-row class="mb-1">
                  <v-col cols="1">
                    <v-card class="color-box pa-3" color="rgba(0, 200, 0,0.4)">
                    </v-card>
                  </v-col>
                  <v-col class="text-left">
                    {{ item.caveID ? 'Segment is relevent for set filters. The exact position is not certain.' : 'Location of this Painted Representation. The exact position is not certain.' }}
                  </v-col>
                </v-row>
                <v-row class="mb-1">
                  <v-col cols="1">
                    <v-card class="color-box pa-3" color="rgba(0, 200, 0,0.8)">
                    </v-card>
                  </v-col>
                  <v-col class="text-left">
                    {{ item.caveID ? 'Segment is relevent for set filters.' : 'Location of this Painted Representation.' }}
                  </v-col>
                </v-row>
                <v-row class="mb-1">
                  <v-col cols="1">
                    <v-card class="color-box pa-3" color="rgba(200, 200, 200,0.8)">
                    </v-card>
                  </v-col>
                  <v-col class="text-left">
                    Segment is not yet recorded or not published in the information system.
                  </v-col>
                </v-row>
                <v-row class="mb-1">
                  <v-col cols="1">
                    <v-card class="color-box pa-3" color="rgba(0, 0, 200,0.4)">
                    </v-card>
                  </v-col>
                  <v-col class="text-left">
                    Segment is already recorded and published in the information system, yet not relevant for set filters. The exact position is not certain.
                  </v-col>
                </v-row>
              <v-row class="mb-1">
                <v-col cols="1">
                  <v-card class="color-box pa-3" color="rgba(0, 0, 200,0.8)">
                  </v-card>
                </v-col>
                <v-col class="text-left">
                  Segment is already recorded and published in the information system, yet not relevant for set filters.
                </v-col>
              </v-row>
            </v-sheet>
                </v-bottom-sheet>
              <v-btn
              v-if="item.caveID"
              class="text-xs-center px-0"
              style="text-align: center;"
              small
              id="button3"
              :attach="'#' +elementID"
                color="primary"
                dark
                @click="requestFullScreen"
                @touchstart.native="requestFullScreen">
                {{fullScreen? "Exit Full Screen": "Full Screen" }}
              </v-btn>
            <v-bottom-sheet hide-overlay persistent max-width="100%" ref="tooltip" v-if="showTag && ($vuetify.breakpoint.smAndDown || fullScreen)"  :attach="'#' +elementID" id="tooltip" style="pointer-events: all !important;"  class="mb-0"  :position-y="yTag" :position-x="xTag" right v-model="showTag" >
              <Cave3DModelTooltip :transparent="false" :darkText="true" :hoveredAnno="hoveredAnno" :relatedDepictions="relatedDepictions" @hideOverlayByClick="hideOverlayByClick"></Cave3DModelTooltip>
            </v-bottom-sheet>
        </v-row>
        <button
          color="primary"
          dark
          class="reset-button"
          @click="resetToInitialPosition">
          <v-icon dark >mdi-compass-rose</v-icon>
        </button>
      </div>
      </v-col>
      </v-row>
</div>
</template>
<script>
import * as THREE from 'three';
import Vue from 'vue'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { PointerLockControls } from 'three/examples/jsm/controls/PointerLockControls.js';
import { XRControllerModelFactory } from 'three/examples/jsm/webxr/XRControllerModelFactory.js';
// import { FirstPersonControls } from 'three/examples/jsm/controls/FirstPersonControls.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import {getWallByID, getIconographyByAnnos, isMobile} from  "@/utils/helpers"
import locationSearch from '@/components/locationSearch.vue'
import Cave3DModelFilterPanel from '@/components/Cave3DModelFilterPanel.vue'
import { HTMLMesh } from '@/utils/HTMLMesh.js';
import { InteractiveGroup } from 'three/addons/interactive/InteractiveGroup.js';
import Cave3DModelTooltip from './Cave3DModelTooltip.vue';
import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter.js';
import VRIconographyMenu from '@/utils/VRIconographyMenu'
import { buildWallCanvas, parseSvgSelector, createMap } from '@/utils/shared-exports.js';
const NIGHT_GLSL = `
uniform float lightMode;
uniform float ambientLevel;
uniform vec3 lampPos;
uniform vec3 lampColor;
uniform float lampIntensity;
uniform float lampRadius;
uniform vec3 sunDir;
uniform vec3 sunColor;
uniform float sunIntensity;

vec3 nightLight(vec3 albedo, vec3 n, vec3 wp) {
  vec3 toLamp = lampPos - wp;
  float d = length(toLamp);
  vec3 L = toLamp / max(d, 1e-4);
  float wrap = clamp((dot(n, L) + 0.25) / 1.25, 0.0, 1.0);

  // harter, heller Lichtkreis (wie bisher)
  float fall = clamp(1.0 - d / lampRadius, 0.0, 1.0);
  fall *= fall;
  float near = fall / (1.0 + 1.5 * d * d);

  // schwacher Schweif: erreicht auch Gewölbe und ferne Wände
  float tail = 0.10 / (1.0 + 0.25 * d * d);

  vec3 lamp = lampColor * lampIntensity * wrap * (near + tail);
  float sunN = max(dot(n, normalize(sunDir)), 0.0);
  vec3 sun = sunColor * sunIntensity * sunN;
  return albedo * (vec3(ambientLevel) + lamp + sun);
}
`
export default {
  name: 'Cave3DModelInf',
  components: {
    locationSearch,
    Cave3DModelFilterPanel,
    Cave3DModelTooltip,
    VRIconographyMenu
  },
  props: {

    item: {},
    relatedDepictions: {
      type: Array,
      default: function () {
        return []
      },
    },
    elementID: {
      type: String,
      default: ""
    },
    fokusOnFirstDepiction: {
      type: Boolean,
      default: false
    }
  },
  data () {

    return {
      selectedLocations:[],
      hoveredAnnoLocked: false,
      backgroundImg: require('@/pics/grid.jpg'),
      isShowingInfo:true,
      sheetLegend: null,
      sheetTree: null,
      hoveredAnno: null,
      hoveredIcos: [],
      hoveredRegister: null,
      motionControllOn: true,
      isDragging: false,
      isZooming: false,
      lastTouchX: 0,
      lastTouchY: 0,
      touchMovedX: 0,
      touchMovedY: 0,
      touchQuaternion: new THREE.Quaternion(),
      touchQuaternionOld: new THREE.Quaternion(),
      initialDistance: 0,
      cameraRotation: new THREE.Euler(0, 0, 0, 'YXZ'),
      touchStartTime:0,
      touchMoved: false,
      yTag: 0,
      xTag: 0,
      showTag: false,
      showTree: false,
      icoAnnos: [],
      annoPrCount:{},
      scene: null,
      renderer:null,
      cave3DModel: null,
      controls: null,
      orbitControls: null,
      currentCamera: null,
      cameraDic: {},
      annotationsByWall: {},
      cave3DInfForWalls: {},
      camera: null,
      search: null,
      icoSelected: [],
      icoActivated: [],
      selectedDepictions:[],
      locationFacets: [],
      fullScreen: false,
      keysPressed: new Set(),
      alpha: 0,
      beta: 0,
      gamma: 0,
      alphaPrev: 0,
      betaPrev: 0,
      gammaPrev: 0,
      fps: 15,
      now: Date.now(),
      then: Date.now(),
      interval: 1000 / 15,
      delta: 0,
      cameraQuaternion: new THREE.Quaternion(),
      currentDistance: null,
      info: "",
      requestDeviceMotion: false,
      sensor: null,
      focusCoordinate: null,
      isVR: false,
      isVRSessionActive: false,
      xrSession: null,
      lastRegister: null,
      pending: false,
      userRig: null,
      knownControllers: new Set(),
      controllerModelFactory: null,
      laserTooltipDistance: 1.0,
      menuMesh: null,
      menuMeshGroup: null,
      prevMenuButtonPressed: false,
      renderVRMode:false,
      leftController: null,
      rightController: null,
      progress: {
        total: 0,
        current: 0,
        currentWall: null,
        visible: false,
        step: ""
      },
      wallShaderDic: {},
      wallCanvasIIIFImageCache: {},
      registerShaderDic: {},
      depictionShaderDic: {},
      IcoDepictionShaderDic: {},
      shaderCount: 0,
      tooltipWidth: 0,
      tooltipHeight: 0,
      // hilfsobjekte für Device Orientation
      _zee: null,
      _euler: null,
      _q0: null,
      _q1: null,
      _deviceQuat: null,
      lastTouchX: 0,
      lastTouchY: 0,
      vrIconographyMenu: null,
      vrMenuGroup: null,
      nightMode: false,
      prevLampButtonPressed: false,
    }
  },
  computed: {
    // filter () {
    //   return  (item, search, textKey) => {
    //     if (item.search) {
    //       // .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    //       return (item["search"].toLowerCase().normalize("NFD").indexOf(search) > -1 || item["name"].toLowerCase().normalize("NFD").indexOf(search) > -1)
    //     } else {
    //       return (item["name"].toLowerCase().normalize("NFD").indexOf(search) > -1)
    //     }
    //   }
    // },
    cave(){
      if (this.item.caveID){
        return this.item
      } else {
        return this.item.cave
      }
    },
  filteredIcoAnnos() {
      if (!this.icoAnnos || this.icoAnnos.length === 0) return []

      // Dieselbe Logik, die vorher im Child war:
      const filterTree = (nodes) => {
        return nodes
          .filter(node => this.annoPrCount[node.iconographyID] > 0)
          .map(node => {
            if (node.children) {
              return { ...node, children: filterTree(node.children) };
            }
            return node;
          });
      };

      return filterTree(this.icoAnnos);
    }
  },
  methods: {

    prepareVRTree(nodes) {

      return nodes.map(node => {

        const copy = {
          ...node,

          annotationCount:
            this.annoPrCount[
              node.iconographyID
            ] || 0
        }

        if (node.children) {

          copy.children =
            this.prepareVRTree(
              node.children
            )
        }

        return copy
      })
    },
createVRIconographyMenu() {
  const group = new InteractiveGroup()
  // KEIN listenToPointerEvents (das ist für Desktop-Maus)
  group.listenToXRControllerEvents(this.renderer.xr.getController(0))
  group.listenToXRControllerEvents(this.renderer.xr.getController(1))
  this.scene.add(group)
  this.vrMenuGroup = group

  this.vrIconographyMenu = new VRIconographyMenu({
    onSelect: (selected) => this.updateicoSelectedParent(selected)
  })

  this.vrIconographyMenu.setNodes(this.prepareVRTree(this.filteredIcoAnnos))
  this.vrIconographyMenu.setSelected(this.icoSelected || [])

  group.add(this.vrIconographyMenu.mesh)
  this.vrIconographyMenu.attachToController(this.leftController, 0.4)
  this.vrIconographyMenu.show()
},
    setRegisterShaderIndex(wallName, dimensionId, reg, no, index) {
      const wallKey = String(wallName);
      const dimensionKey = String(dimensionId ?? "default");
      const regKey = String(reg);
      const noKey = String(no);

      if (!this.registerShaderDic[wallKey]) {
        this.registerShaderDic[wallKey] = {};
      }
      if (!this.registerShaderDic[wallKey][dimensionKey]) {
        this.registerShaderDic[wallKey][dimensionKey] = {};
      }
      if (!this.registerShaderDic[wallKey][dimensionKey][regKey]) {
        this.registerShaderDic[wallKey][dimensionKey][regKey] = {};
      }

      this.registerShaderDic[wallKey][dimensionKey][regKey][noKey] = index;
    },
    getRegisterShaderIndex(wallName, dimensionId, reg, no) {
      const wallRegisters = this.registerShaderDic[String(wallName)];
      if (!wallRegisters) return null;

      const dimensionKey = String(dimensionId ?? "default");
      const regKey = String(reg);
      const noKey = String(no);

      return wallRegisters[dimensionKey]?.[regKey]?.[noKey] ?? null;
    },
    getBarycentricCoords(p, a, b, c) {
      const v0 = b.clone().sub(a);
      const v1 = c.clone().sub(a);
      const v2 = p.clone().sub(a);

      const d00 = v0.dot(v0);
      const d01 = v0.dot(v1);
      const d11 = v1.dot(v1);
      const d20 = v2.dot(v0);
      const d21 = v2.dot(v1);

      const denom = d00 * d11 - d01 * d01;
      if (denom === 0) return null;

      const v = (d11 * d20 - d01 * d21) / denom;
      const w = (d00 * d21 - d01 * d20) / denom;
      const u = 1 - v - w;

      if (u < 0 || v < 0 || w < 0) return null;

      return new THREE.Vector3(u, v, w);
    },
    getWorldFromUV(mesh, u, v) {
      const geometry = mesh.geometry;
      if (!geometry.attributes.uv || !geometry.index) return null;

      const posAttr = geometry.attributes.position;
      const uvAttr = geometry.attributes.uv;
      const index = geometry.index.array;

      for (let i = 0; i < index.length; i += 3) {
        const a = index[i], b = index[i + 1], c = index[i + 2];

        const uvA = new THREE.Vector2().fromBufferAttribute(uvAttr, a);
        const uvB = new THREE.Vector2().fromBufferAttribute(uvAttr, b);
        const uvC = new THREE.Vector2().fromBufferAttribute(uvAttr, c);

        const uvP = new THREE.Vector2(u, v);
        const bary = getBarycentricCoords(uvP, uvA, uvB, uvC);
        if (!bary) continue;

        // Interpolation im 3D-Raum
        const posA = new THREE.Vector3().fromBufferAttribute(posAttr, a);
        const posB = new THREE.Vector3().fromBufferAttribute(posAttr, b);
        const posC = new THREE.Vector3().fromBufferAttribute(posAttr, c);

        const worldPos = new THREE.Vector3()
          .addScaledVector(posA, bary.x)
          .addScaledVector(posB, bary.y)
          .addScaledVector(posC, bary.z);

        // In Weltkoordinaten transformieren
        return worldPos.applyMatrix4(mesh.matrixWorld);
      }

      return null;
    },

    waitForImagesToLoad(container) {
      const images = Array.from(container.querySelectorAll('img'));
      return Promise.all(images.map(img => {
        return new Promise(resolve => {
          const onLoadOrError = () => {
            img.removeEventListener('load', onLoadOrError);
            img.removeEventListener('error', onLoadOrError);
            resolve();
          };

          if (img.complete && img.naturalHeight !== 0) {
            resolve();
          } else {
            img.addEventListener('load', onLoadOrError);
            img.addEventListener('error', onLoadOrError);
          }
        });
      }));
    },

    async renderRegisterTooltipToTexture(register) {
      try {
        this.hoveredAnno = JSON.parse(register.body[0].value)
        const TooltipClass = Vue.extend(Cave3DModelTooltip);
        const instance = new TooltipClass({
          propsData: {
            hoveredAnno: this.hoveredAnno,
            relatedDepictions: this.relatedDepictions,
            transparent: false,
            darkText: false,
            limitHeight: false
          }
        });

        instance.$mount(); // rendert in-memory
        document.body.appendChild(instance.$el);

        await this.waitForImagesToLoad(instance.$el);
        const htmlMesh = new HTMLMesh(instance.$el);
        return htmlMesh;
      } catch (error) {
        this.$log.error(error);
        this.pending = false;
      }

    },
    updateTooltipTexture(register) {
      try {
        if (!register || register === this.currentRegister || this.pending) return;
        this.pending = true;
        this.currentRegister = register;

        this.renderRegisterTooltipToTexture(register).then(htmlMesh => {
          this.pending = false;

          if (!htmlMesh) return;

          // Alten Mesh entfernen
          if (this.annotationMesh) {
            this.scene.remove(this.annotationMesh);
            this.annotationMesh.geometry.dispose();
            this.annotationMesh.material.map.dispose();
            this.annotationMesh.material.dispose();
          }
          this.annotationMesh = htmlMesh;
          // Positionierung wird in der Loop gemacht!
        });
      } catch (error) {
        this.pending = false;
      }
    },

    addLaserPointer(controller, color = 0x00ff00, length = 5) {
      const geometry = new THREE.BufferGeometry().setFromPoints([
        new THREE.Vector3(0, 0, 0),
        new THREE.Vector3(0, length, 0)  // zeigt nach vorne
      ]);
      const material = new THREE.LineBasicMaterial({ color });
      const laser = new THREE.Line(geometry, material);
      laser.name = 'laserPointer';
      //laser.position.z = 0.03;
      //laser.position.y = 0.02;
      laser.rotation.x = THREE.MathUtils.degToRad(-90);
      controller.add(laser);
    },
    async waitForControllers(maxWaitMs = 4000){
      return new Promise((resolve) => {
        const check = () => {
          if (this.xrSession.inputSources.length > 0) {
            resolve(this.xrSession.inputSources);
          } else if (maxWaitMs <= 0) {
            resolve([]);
          } else {
            setTimeout(() => {
              maxWaitMs -= 100;
              check();
            }, 100);
          }
        };
        check();
      });
    },
    setLeftMenuLaserVisible(visible) {
      const laser = this.leftController?.getObjectByName('laserPointer');

      if (laser) {
        laser.visible = visible;
      }
    },
    tryMoveInDirection(directionVec, moveDistance) {
      const raycaster = new THREE.Raycaster();
      const buffer = 0.1;

      // Ursprung: Position des Rigs
      const origin = this.userRig.position.clone();
      const direction = directionVec.clone().normalize();

      // Ray leicht vor den Nutzer setzen, für frühes Erkennen
      const rayOrigin = origin.clone().addScaledVector(direction, buffer);
      raycaster.set(rayOrigin, direction);
      raycaster.far = moveDistance + buffer;

      const collisionTargets = this.getAllMashes([], this.scene); // deine Funktion
      const hits = raycaster.intersectObjects(collisionTargets, true); // rekursiv = true

      if (hits.length === 0) {
        this.userRig.position.addScaledVector(direction, moveDistance);
      } else {
        console.log("🚫 Kollision mit:", hits[0].object.name || hits[0].object);
      }

      // // 🔍 Debug-Hilfe (nach 0.5s entfernt)
      // const arrowHelper = new THREE.ArrowHelper(direction, rayOrigin, raycaster.far, 0xff0000);
      // this.scene.add(arrowHelper);
      // setTimeout(() => this.scene.remove(arrowHelper), 500);
    },

    async toggleVR() {
      this.hoveredAnnoLocked = false
      this.setLODStoLevel(0);
      this.renderVRMode = true;
      this.showTree = true
      this.userRig = new THREE.Group();
      this.scene.add(this.userRig);
      const camera = this.renderer.xr.getCamera();
      this.userRig.add(camera);
      if (!navigator.xr) {
        console.warn("WebXR not available");
        return;
      }

      if (this.xrSession) {
        await this.xrSession.end();
        return;
      }

      const sessionInit = {
        requiredFeatures: ['local-floor'],
        optionalFeatures: ['hand-tracking']
      };

      try {
        const session = await navigator.xr.requestSession('immersive-vr', sessionInit);

        session.addEventListener('end', () => {
          this.xrSession = null;
          this.renderVRMode = false;
          this.isVRSessionActive = false;
          this.renderer.setAnimationLoop(null); // Wichtig: Animation Loop stoppen
        });

        await this.renderer.xr.setSession(session);

        const referenceSpace = await session.requestReferenceSpace('local-floor');
        this.renderer.xr.setReferenceSpace(referenceSpace);
        console.log("Reference space type:", referenceSpace.type);

        this.xrSession = session;
        this.isVRSessionActive = true;


        const setupController = (index) => {
          if (index === 0) this.leftController = this.renderer.xr.getController(index);
          if (index === 1) this.rightController = this.renderer.xr.getController(index);
          const controller = this.renderer.xr.getController(index);
          controller.visible = true;

          controller.addEventListener('selectstart', () => {
            console.log(`Controller ${index} selectstart`);
          });

          if (index === 1) {
            this.addLaserPointer(controller, 0x00ff00, 5);
          }

          this.userRig.add(controller);

          // === GRIP + MODELL ===
          const grip = this.renderer.xr.getControllerGrip(index);
          const model = this.controllerModelFactory.createControllerModel(grip);
          // model.rotation.x = -Math.PI / 4;
          // // Modell sofort anhängen – nicht erst in 'connected'
          // const correctionNode = new THREE.Object3D();
          // correctionNode.rotation.x = -Math.PI / 4; // Falls nötig
          // correctionNode.add(model);

          grip.add(model);
          this.userRig.add(grip);

          // Sichtbarkeit: erst nach dem Laden
          model.addEventListener('connected', () => {
            grip.visible = true;
            console.log(`Controller model ${index} connected`);
          });

          // Falls 'connected' nicht triggert: Notfalllösung
          setTimeout(() => {
            if (!grip.visible && model.children.length > 0) {
              grip.visible = true;
            }
          }, 1000);
        };

        // Bestehende Input-Quellen verarbeiten
        // session.inputSources.forEach((_, i) => setupController(i));
        setTimeout(() => {
          session.inputSources.forEach((inputSource, i) => {
            if (!this.knownControllers.has(inputSource)) {
              setupController(i);
              this.knownControllers.add(inputSource);
            }
          });
        }, 500);

        session.addEventListener('inputsourceschange', () => {
          session.inputSources.forEach((inputSource, i) => {
            if (!this.knownControllers.has(inputSource)) {
              setupController(i);
              this.knownControllers.add(inputSource);
            }
          });
        });
        let needsVRAlignment = true;
        // VR Rendering Loop
        setTimeout(() => {
          this.renderer.setAnimationLoop(() => {
              const camera = this.renderer.xr.getCamera();
              if (needsVRAlignment && camera.position.y > 0.1) {

              const euler = new THREE.Euler().setFromQuaternion(camera.quaternion, 'YXZ');
              const targetYaw = Math.PI / 2; // Auf +X-Achse schauen

              this.userRig.rotation.y = targetYaw - euler.y;
              needsVRAlignment = false;
              console.log("VR View aligned to X-Axis!");
            }
            // Controller-Input
            const session = this.renderer.xr.getSession();
            if (session) {

              if (session.inputSources.length > 0 && session.inputSources[0].handedness) {
                const inputSource = session.inputSources[0].handedness === 'left' ? session.inputSources[0] : session.inputSources[1]; // ggf. Index prüfen

                if (inputSource && inputSource.gamepad) {
            // Menu
            if (
              !this.prevMenuButtonPressed &&
              inputSource.gamepad.buttons[4].pressed
            ) {
              if (!this.vrIconographyMenu) {

                this.createVRIconographyMenu();

                this.addLaserPointer(this.leftController, 0x00ff00, 2);

                this.vrIconographyMenu.attachToController(
                  this.leftController,
                  0.40
                );

                this.setLeftMenuLaserVisible(true);

              } else {

                if (this.vrIconographyMenu.visible) {

                  // Menü schließen und linken Laser ausblenden
                  this.vrIconographyMenu.hide();
                  this.setLeftMenuLaserVisible(false);

                } else {

                  // Menü öffnen und linken Laser wieder anzeigen
                  this.vrIconographyMenu.attachToController(
                    this.leftController,
                    0.40
                  );

                  this.vrIconographyMenu.show();
                  this.setLeftMenuLaserVisible(true);
                }
              }
            }

            // Zustand fürs nächste Frame merken
            this.prevMenuButtonPressed = inputSource.gamepad.buttons[4].pressed;                  // Zustand fürs nächste Frame merken
                  this.prevMenuButtonPressed = inputSource.gamepad.buttons[4].pressed;
                  // Navigation
                  const speed = 0.03;
                  const axes = inputSource.gamepad.axes;
                  const x = axes[2]; // Links/Rechts
                  const y = axes[3]; // Vor/Zurück

                  if (Math.abs(x) > 0.05 || Math.abs(y) > 0.05) {
                    // Blickrichtung holen
                    const forward = new THREE.Vector3();
                    camera.getWorldDirection(forward);
                    forward.normalize();

                    // Seitwärtsrichtung (horizontal)
                    const side = new THREE.Vector3(1, 0, 0).applyQuaternion(camera.quaternion);
                    side.y = 0;
                    side.normalize();

                    if (Math.abs(x) > 0.05) {
                      this.tryMoveInDirection(side, x * speed);
                    }
                    if (Math.abs(y) > 0.05) {
                      this.tryMoveInDirection(forward, -y * speed);
                    }
                  }

                }
                const inputSource2 = session.inputSources[0].handedness === 'left' ? session.inputSources[0] : session.inputSources[1]; // ggf. Index prüfen
                const lampPressed = !!inputSource2.gamepad.buttons[5]?.pressed
                if (lampPressed && !this.prevLampButtonPressed) {
                  this.toggleNightMode()
                }
              this.prevLampButtonPressed = lampPressed
                if (inputSource2 && inputSource2.gamepad) {
                  const toolTippY = inputSource2.gamepad.axes[3]; // Joystick Y
                  const moveSpeed = 0.02;

                  // Bewegung des Tooltip entlang des Lasers (z. B. vor/zurück)
                  this.laserTooltipDistance += -toolTippY * moveSpeed;

                  // Begrenzung (optional)
                  this.laserTooltipDistance = Math.max(0.1, Math.min(3, this.laserTooltipDistance));

                }
              }
            }
            const controller = this.renderer.xr.getController(1); // oder 1
            const laser = controller.getObjectByName('laserPointer');
            if (laser) {
              const raycaster = new THREE.Raycaster();

              // Position aus dem Laser entnehmen (weltweit)
              const laserOrigin = new THREE.Vector3();
              laser.getWorldPosition(laserOrigin);

              // Richtung des Lasers aus seiner Matrix ableiten
              const laserDirection = new THREE.Vector3(0, 1, 0); // weil dein Laser „nach oben“ zeigt

              laserDirection.applyQuaternion(laser.getWorldQuaternion(new THREE.Quaternion()));
              // const arrowHelper = new THREE.ArrowHelper(
              //   laserDirection,   // normalisierter Vektor
              //   laserOrigin,      // Startpunkt (Position)
              //   6,           // Länge (z. B. 1 Meter)
              //   0xff0000     // Farbe (z. B. rot)
              // );
              // this.scene.add(arrowHelper);
              raycaster.set(laserOrigin, laserDirection);

              const group = this.scene.children.find(obj => obj.type === 'Group');
              if (group) {
                const intersects = raycaster.intersectObjects(group.children, true);
                const register = this.findRegisterByIntersection(intersects)
              if (register) {
                this.updateTooltipTexture(register);
                if (this.annotationMesh) {
                  const offsetDistance = 0.35;

                  // Ursprüngliche Position am Laser-Endpunkt
                  const laserEndPoint = laserOrigin.clone().add(
                    laserDirection.clone().multiplyScalar(this.laserTooltipDistance)
                  );


                  // Berechne "rechts" = Laser-Richtung × Welt-"up"
                  const up = new THREE.Vector3(1, 0, 0);
                  const right = new THREE.Vector3().crossVectors(laserDirection, up).normalize();

                  // Optional: nach oben verschieben
                  const upward = new THREE.Vector3().crossVectors(right, laserDirection).normalize();

                  // Versetze Mesh ein Stück zur Seite und oben
                  const offset = new THREE.Vector3()
                    .addScaledVector(right, offsetDistance)    // seitlich
                    .addScaledVector(upward, offsetDistance);  // nach oben

                  this.annotationMesh.position.copy(laserEndPoint.clone().add(offset));

                  // Richtung zur Kamera
                  const cameraWorldPos = new THREE.Vector3();
                  this.renderer.xr.getCamera().getWorldPosition(cameraWorldPos);
                  this.annotationMesh.lookAt(cameraWorldPos);
                  this.scene.add(this.annotationMesh);
                }
              } else {
                // Kein Treffer mehr → Tooltip ausblenden
                if (this.annotationMesh) {
                  this.scene.remove(this.annotationMesh);
                  this.annotationMesh.geometry.dispose();
                  this.annotationMesh.material.map.dispose();
                  this.annotationMesh.material.dispose();
                  this.annotationMesh = null;
                }
                this.showTag = false;
                this.lastRegister = null;
              }
              }
            }
            this.updateNightLight()
            this.renderer.render(this.scene, camera);
          });
        }, 1000)


      } catch (e) {
        console.log("VR session start failed:", e);
      }
    },

    switchToVR() {
      this.renderer.xr.enabled = true;
      this.toggleVR();
    },
    checkVR(){
      if (navigator.xr) {
        this.isVR = true
      } else {
        this.isVR = false
      }
    },
    getLegendLabel(){
      if (this.sheetLegend){
        return "Legend"
      } else {
        return "Legend"
      }
    },
    setLocations(newValue){
      this.selectedLocations = newValue
    },
    updateicoSelectedParent(icoSelected){
      console.log("icoSelected triggered", icoSelected);

      this.icoSelected = icoSelected
    },
    getLabelEnablePointControllsMobile(){
      if (this.motionControllOn){
        return "motion on"
      } else {
        return "motion off"
      }
    },

    enablePointControllsMobile(event){
      event.preventDefault()
      event.stopPropagation()
      if (this.motionControllOn){
        window.removeEventListener('deviceorientation', this.handleOrientation);
        this.touchQuaternion = new THREE.Quaternion()
      } else {

        window.addEventListener('deviceorientation', this.handleOrientation);
      }
      this.motionControllOn = !this.motionControllOn
    },
    handleOrientation(event) {
      if (this.controls.enabled){
        this.alpha = event.alpha; // Z axis (compass direction)
        this.beta = event.beta; // X axis (tilt front-to-back)
        this.gamma = event.gamma; // Y axis (tilt left-to-right)
        this.isShowingInfo = true;
      }
    },
    saveModel(objectToSave, filename = 'scene.glb') {
      function downloadFile(blob, filename) {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      }
      console.log("saveModel triggered", objectToSave);
        const exporter = new GLTFExporter();

        // Optionen für den Export. 'binary: true' erstellt eine .glb-Datei
        const options = {
            binary: true,
        };

        // Die .parse()-Methode konvertiert das Objekt in die Daten
        exporter.parse(
            objectToSave,
            function (result) {
                // Die Export-Daten in ein Blob umwandeln
                const blob = new Blob([result], { type: 'application/octet-stream' });
                // Den Download auslösen
                downloadFile(blob, filename);
                console.log(`Modell als ${filename} gespeichert!`);
            },
            // Optionaler Fehler-Callback
            function (error) {
                console.error('Fehler beim Exportieren des Modells:', error);
            },
            options
        );
    },

    checkLocation(pr){
      if (this.selectedLocations.length === 0){
        return true
      } else {
        console.log("locations selected");
        for (const location of this.selectedLocations){
          if (pr.location) {
            if (pr.location.locationID === location.locationID){
              return true
            }
            return false
          } else {
            return false
          }
        }
        return false
      }
    },
    updateAnnoPrCount(item) {
      const ids = this.getAllIDs(item, []);

      const matchesIconography = (pr) => {
        const hasAnno = pr.relatedAnnotationList?.some(anno =>
          anno.tags?.some(tag => ids.includes(tag.iconographyID))
        );
        const hasIcono = pr.relatedIconographyList?.some(icono =>
          ids.includes(icono.iconographyID)
        );
        return (hasAnno || hasIcono) && this.checkLocation(pr);
      };

      this.annoPrCount[item.iconographyID] = this.relatedDepictions.filter(matchesIconography).length;

      item.children?.forEach(child => this.updateAnnoPrCount(child));
    },
    initUpdateAnnoPrCount(){
      this.annoPrCount = {}
      for (const item of this.icoAnnos){
        this.updateAnnoPrCount(item)
      }
      console.log("initUpdateAnnoPrCount", this.annoPrCount);

    },
    getAllIDs(item, ids){
      ids.push(item.iconographyID)
      for (const child of item.children){
        ids = this.getAllIDs(child, ids)
      }
      return ids
    },
    changedLocationInput(value){
      this.selectDepictionsByicoSelected()
      this.initUpdateAnnoPrCount()
      this.prepLocationAggs()
    },
    selectDepictionsByicoSelected() {
      console.log("selectDepictionsByicoSelected triggered", this.icoSelected, this.selectedLocations);
      var selectedDepictions = [];
      const matchesLocation = (pr) => {
        return this.selectedLocations.length === 0 || (
          pr.location &&
          this.selectedLocations.some(loc => loc.locationID === pr.location.locationID)
        );
      };
      if (this.icoSelected.length === 0) {
        if (this.selectedLocations.length > 0) {
          console.log("filtering depictions with selected locations");
          selectedDepictions = this.relatedDepictions
            .filter(pr => matchesLocation(pr))
            .map(pr => pr.depictionID);
        } else {
          selectedDepictions = []
        }
      } else {
        for (const pr of this.relatedDepictions) {
          let match = false;

          for (const ico of this.icoSelected) {
            const icoID = ico.iconographyID;

            const hasAnnotationMatch = pr.relatedAnnotationList?.some(anno =>
              anno.tags?.some(tag => tag.iconographyID === icoID)
            );

            const hasIconographyMatch = pr.relatedIconographyList?.some(icono =>
              icono.iconographyID === icoID
            );

            if ((hasAnnotationMatch || hasIconographyMatch) && matchesLocation(pr)) {
              selectedDepictions.push(pr.depictionID);
              match = true;
              break; // skip further ico checks if already matched
            }
          }
        }
      }
      this.selectedDepictions = selectedDepictions;
      this.prepLocationAggs();
    },
    initIcoTree(){
      this.icoAnnos = []
      let allAnnotationEntries = []
      for (const pr of this.relatedDepictions){
        for (var ae of pr.relatedAnnotationList) {
          for (var ico of ae.tags) {
            if (!allAnnotationEntries.includes(ico)) {
              allAnnotationEntries.push(ico.iconographyID);
            }
          }
        }
        for (var icoEntry of pr.relatedIconographyList) {
          if (!allAnnotationEntries.includes(icoEntry)) {
            allAnnotationEntries.push(icoEntry.iconographyID);
          }
        }
      }
      this.icoAnnos = getIconographyByAnnos(allAnnotationEntries)
      this.$emit("initIcoTree", this.icoAnnos)
      console.log("this.icoAnnos", this.icoAnnos);
    },
    grantAccessToMobileMotion(event){
      // Bei iOS 13+ musst du die Erlaubnis anfragen
      this.requestDeviceMotion = false
      window.DeviceMotionEvent.requestPermission()
        .then(permissionState => {
          if (permissionState === 'granted') {
            window.addEventListener('deviceorientation', this.handleOrientation);
          } else {
            this.info = 'Gyroskop-Sensoren abgelehnt'
          }
        })
        .catch(error =>{
          this.info = error
        });
    },

    handleMotion(event) {
      const acceleration = event.accelerationIncludingGravity;
      if (acceleration.x > 2) {
        this.keysPressed.add('d');
        this.keysPressed.delete('a');
      } else if (acceleration.x < -2) {
        this.keysPressed.add('a');
        this.keysPressed.delete('d');
      } else {
        this.keysPressed.delete('d');
        this.keysPressed.delete('a');
      }

      if (acceleration.y > 2) {
        this.keysPressed.add('s');
        this.keysPressed.delete('w');
      } else if (acceleration.y < -2) {
        this.keysPressed.add('w');
        this.keysPressed.delete('s');
      } else {
        this.keysPressed.delete('w');
        this.keysPressed.delete('s');
      }
    },

    getLabelOpenAnnotations(){
      if (isMobile()){
        return "TREE"
      }
      if (this.showTree !== true){
        return "Open Filter Bar"
      } else {
        return "Close Filter Bar"
      }
    },
    getWallName(wallNumberStr){
      if (wallNumberStr === "000"){
        return "outside view"
      } else {
        var wallNumber = parseInt(wallNumberStr, 10);
        let wallTree = getWallByID(wallNumber, this.$store.state.wallLocation)
        return wallTree ? wallTree.name : "undefined"
      }
    },
    hasTouch() {
      console.log("touchDevice check", window.matchMedia("(pointer: coarse)").matches);

      return window.matchMedia("(pointer: coarse)").matches
    },
    setLODStoLevel(level) {
      console.log("setLODStoLevel", level)
      for (const wallName in this.wallShaderDic) {
        if (level === this.wallShaderDic[wallName].activeTexture) return
        this.wallShaderDic[wallName].mesh.material.uniforms.baseTexture.value = this.wallShaderDic[wallName].textures[level];
        this.wallShaderDic[wallName].mesh.material.uniforms.baseTexture.value.needsUpdate = true;
        this.wallShaderDic[wallName].activeTexture = level
      }
    },
    setLODLevel(wall, level) {
      if (level === wall.activeTexture) return false
      wall.mesh.material.uniforms.baseTexture.value = wall.textures[level];
      if (wall.mesh.material.uniforms.baseTexture.value === undefined) return false
      wall.mesh.material.uniforms.baseTexture.value.needsUpdate = true;
      wall.activeTexture = level
      return true
    },
    getCenterWall(camera) {
      const raycaster = new THREE.Raycaster();
      const direction = new THREE.Vector3();

      // Blickrichtung der Kamera
      camera.getWorldDirection(direction);

      // Ray von Kameraposition in Blickrichtung
      raycaster.set(camera.position, direction);

      // Nur Shader-Walls testen
      const objects = Object.values(this.wallShaderDic).map(entry => entry.mesh);

      const intersects = raycaster.intersectObjects(objects, true);
      if (intersects.length > 0) {
        return intersects[0].object; // nächstgelegenes Mesh im Zentrum
      }
      return null;
    },
    updateLODs(camera) {
      const centerWall = this.getCenterWall(camera);

      let high = 0, mid = 0, low = 0;

      for (const wallName in this.wallShaderDic) {
        const entry = this.wallShaderDic[wallName];
        const wall = entry.mesh;

        if (wall === centerWall) {
          if (this.setLODLevel(entry, 0)) high++;
        } else {
          if (this.setLODLevel(entry, 1)) low++;
        }
      }

      this.$log.debug(`high: ${high}, low: ${low}`);
    },
    getDeviceQuaternion() {

      const alpha = THREE.MathUtils.degToRad(this.alpha || 0)
      const beta  = THREE.MathUtils.degToRad(this.beta  || 0)
      const gamma = THREE.MathUtils.degToRad(this.gamma || 0)

      const orient =
        THREE.MathUtils.degToRad(
          window.screen.orientation?.angle || window.orientation || 0
        )

      this._euler.set(beta, alpha, -gamma, 'YXZ')

      this._deviceQuat.setFromEuler(this._euler)

      // Kamera schaut standardmäßig nach -Z
      this._deviceQuat.multiply(this._q1)

      // Bildschirmrotation korrigieren
      this._deviceQuat.multiply(
        this._q0.setFromAxisAngle(this._zee, -orient)
      )

      return this._deviceQuat
    },
    removeCameraRoll(q){

      const e = new THREE.Euler().setFromQuaternion(q,'YXZ')

      e.z = 0

      q.setFromEuler(e)

      return q
    },
    animate() {
      requestAnimationFrame(() => this.animate());
      this.now = Date.now();
      this.delta = this.now - this.then;
      if (this.delta > this.interval) {
        this.then = this.now - (this.delta % this.interval);
        if (isMobile()) {

          if (
            this.alpha !== this.alphaPrev ||
            this.beta  !== this.betaPrev  ||
            this.gamma !== this.gammaPrev ||
            !this.touchQuaternion.equals(this.touchQuaternionOld)
          ){

            this.alphaPrev = this.alpha
            this.betaPrev  = this.beta
            this.gammaPrev = this.gamma

            const q = this.getDeviceQuaternion()

            this.removeCameraRoll(q)

            this.currentCamera.quaternion.copy(q)

            // Touch Rotation addieren
            this.currentCamera.quaternion.multiply(this.touchQuaternion)

            this.touchQuaternionOld.copy(this.touchQuaternion)

          }

        }
        if (this.controls.isLocked) {

          const moveDistance = 0.05; // Adjust the move distance as needed

          if (this.keysPressed.has('ArrowUp') || this.keysPressed.has('w')) {
            this.moveCameraIfNoCollision(this.currentCamera, moveDistance, 'forward');
          }
          if (this.keysPressed.has('ArrowDown') || this.keysPressed.has('s')) {
            this.moveCameraIfNoCollision(this.currentCamera, moveDistance, 'backward');
          }
          if (this.keysPressed.has('ArrowLeft') || this.keysPressed.has('a')) {
            this.moveCameraIfNoCollision(this.currentCamera, moveDistance, 'left');
          }
          if (this.keysPressed.has('ArrowRight') || this.keysPressed.has('d')) {
            this.moveCameraIfNoCollision(this.currentCamera, moveDistance, 'right');
          }
          // this.updateLODs(this.currentCamera)
        }
        if (this.orbitControls.enabled  && this.orbitControls.hasMoved){
          this.orbitControls.update();
          // this.updateLODs(this.currentCamera)
        }


        this.renderer.render(this.scene, this.currentCamera);
      }
    },
    switchCamera(camera) {
      if (this.controls && this.orbitControls){
        this.currentCamera.position.x = camera.position.x
        this.currentCamera.position.y = camera.position.y
        this.currentCamera.position.z = camera.position.z
        this.currentCamera.fov = camera.fov
        this.currentCamera.aspect = (document.getElementById(this.elementID).offsetWidth, document.getElementById(this.elementID).offsetHeight);
        if (camera.name === "000"){
          this.controls.enabled = false;
          this.orbitControls.enabled = true
        } else {
          this.controls.enabled = true;
          this.orbitControls.enabled = false
        }
      }

    },
    parsePathData(pathData) {
      // Leerzeichen nach Kommas entfernen und Z-Befehl ignorieren
      const cleaned = pathData.replace(/,\s+/g, ',').replace(/Z/gi, '');
      const matches = [...cleaned.matchAll(/([ML])\s*(-?[\d.]+),\s*(-?[\d.]+)/g)];

      return matches.map(match => ({
        x: parseFloat(match[2]),
        y: parseFloat(match[3])
      }));
    },


    toggleNightMode() {
      if (this.nightMode) this.disableNightMode()
      else this.enableNightMode()
      this.nightMode = !this.nightMode
    },

    makeNightMaterial(orig) {
  return new THREE.ShaderMaterial({
    uniforms: {
      baseMap:   { value: orig.map || null },
      hasMap:    { value: orig.map ? 1 : 0 },
      baseColor: { value: orig.color ? orig.color.clone() : new THREE.Color(1, 1, 1) },
      ...this._lampUniforms            // gleiche Objekte -> Updates wirken überall
    },
    vertexShader: `
      varying vec2 vUv; varying vec3 vWorldPos; varying vec3 vNormal;
      void main() {
        vUv = uv;
        vNormal = normalize(mat3(modelMatrix) * normal);
        vec4 wp = modelMatrix * vec4(position, 1.0);
        vWorldPos = wp.xyz;
        gl_Position = projectionMatrix * viewMatrix * wp;
      }`,
    fragmentShader: `
      precision highp float;
      uniform sampler2D baseMap;
      uniform float hasMap;
      uniform vec3 baseColor;
      varying vec2 vUv; varying vec3 vWorldPos; varying vec3 vNormal;
      ${NIGHT_GLSL}
      void main() {
        vec3 c = baseColor;
        if (hasMap > 0.5) c *= texture2D(baseMap, vUv).rgb;
        vec3 n = normalize(vNormal);
        if (!gl_FrontFacing) n = -n;
        gl_FragColor = vec4(nightLight(c, n, vWorldPos), 1.0);
      }`,
    side: orig.side
  })
    },

    enableNightMode() {
      const backup = {
        emissive: [], lights: [], materials: [],
        background: this.scene.background
      }

      // 1) Emissive überall aus
      this.scene.traverse(obj => {
        if (!obj.isMesh || !obj.material) return
        const mats = Array.isArray(obj.material) ? obj.material : [obj.material]
        for (const m of mats) {
          if (m.isShaderMaterial) {
            const u = m.uniforms.emissiveIntensity
            if (u) { backup.emissive.push({ target: u, key: 'value', old: u.value }); u.value = 0 }
          } else if (m.emissive) {
            backup.emissive.push({ target: m, key: 'emissiveIntensity', old: m.emissiveIntensity })
            m.emissiveIntensity = 0
          }
        }
      })

      // 2) Nicht-Shader-Meshes des Modells (ohne Annotationen) auf Nacht-Material
      //    (nur Höhlenmodell, damit Tooltips, Menü und Controller unberührt bleiben)
      this.cave3DModel?.scene.traverse(obj => {
        if (!obj.isMesh || !obj.material) return
        if (Array.isArray(obj.material) || obj.material.isShaderMaterial) return
        backup.materials.push({ mesh: obj, material: obj.material })
        obj.material = this.makeNightMaterial(obj.material)
      })

      // 3) Vorhandene Lichter entfernen
      const lights = []
      this.scene.traverse(o => { if (o.isLight) lights.push(o) })
      for (const l of lights) {
        backup.lights.push({ light: l, parent: l.parent })
        l.removeFromParent()
      }
      this._nightBackup = backup

      // 4) Himmel und Sonne (beleuchtet echte Materialien wie den Boden)
      this.scene.background = new THREE.Color(0x87b5e0)
      this._sun = new THREE.DirectionalLight(0xfff2d8, 2.5)
      this._sun.position.set(20, 30, 15)
      this.scene.add(this._sun)

      // 5) Öllampe
      const hand = this.leftController || this.rightController
      if (hand) {
        this._lamp = new THREE.Group()
        this._lamp.position.set(0, 0.04, -0.06)
        this._lampLight = new THREE.PointLight(0xffa640, 3, this._lampUniforms.lampRadius.value, 2)
        this._flame = new THREE.Mesh(
          new THREE.SphereGeometry(0.012, 12, 12),
          new THREE.MeshBasicMaterial({ color: 0xffc060 })
        )
        this._flame.userData.vrMenu = true
        this._lamp.add(this._lampLight, this._flame)
        hand.add(this._lamp)
      }

      this._lampUniforms.lightMode.value = 1
    },

    disableNightMode() {
      const b = this._nightBackup
      if (b) {
        for (const e of b.emissive) e.target[e.key] = e.old
        for (const { mesh, material } of b.materials) {
          mesh.material.dispose()
          mesh.material = material
        }
        for (const { light, parent } of b.lights) if (parent) parent.add(light)
        this.scene.background = b.background
      }
      this._nightBackup = null

      if (this._sun) { this._sun.removeFromParent(); this._sun.dispose?.(); this._sun = null }
      if (this._lamp) {
        this._lamp.removeFromParent()
        this._flame.geometry.dispose()
        this._flame.material.dispose()
        this._lamp = this._lampLight = this._flame = null
      }
      this._lampUniforms.lightMode.value = 0
      this._lampUniforms.lampIntensity.value = 0
    },

    updateNightLight() {
      if (!this.nightMode || !this._lamp) return
      const t = performance.now() / 1000

      // Flackern: mehrere Sinuswellen plus gelegentliches Zucken
      let f = 0.85
        + 0.10 * Math.sin(t * 9.3)
        + 0.06 * Math.sin(t * 23.7 + 1.7)
        + 0.04 * Math.sin(t * 41.1 + 0.4)
      if (Math.random() < 0.02) f -= 0.25
      f = Math.max(0.35, f)

      this._lampLight.intensity = 3 * f
      this._lampLight.color.setHSL(0.07 + 0.012 * Math.sin(t * 7), 1, 0.55)
      this._flame.scale.setScalar(0.8 + 0.5 * f)

      const u = this._lampUniforms
      this._lamp.getWorldPosition(u.lampPos.value)
      u.lampColor.value.copy(this._lampLight.color)
      u.lampIntensity.value = 4 * f
    },


    buildWallEntry(mesh, baseCanvas) {
      // High (Original)
      let textures = []
      const highTex = new THREE.CanvasTexture(baseCanvas);
      highTex.flipY = false;
      highTex.generateMipmaps = false;
      highTex.colorSpace = THREE.SRGBColorSpace;
      highTex.minFilter = THREE.LinearFilter;
      highTex.magFilter = THREE.LinearFilter;
      highTex.wrapS = THREE.ClampToEdgeWrapping;
      highTex.wrapT = THREE.ClampToEdgeWrapping;
      highTex.generateMipmaps = false;
      highTex.needsUpdate = true;
      // texture.colorSpace = THREE.SRGBColorSpace;
      highTex.format = THREE.RGBAFormat;
      highTex.anisotropy = this.renderer.capabilities.getMaxAnisotropy(); // für Schärfe
      textures.push(highTex);
      // Mid
      const optimalTextureSize = this.getOptimalTextureSize();
      if (optimalTextureSize < baseCanvas.width) {
        const midCanvas = this.downscaleCanvas(baseCanvas, this.getOptimalTextureSize());
        const midTex = new THREE.CanvasTexture(midCanvas);
        midTex.flipY = false;
        midTex.generateMipmaps = false;
        midTex.colorSpace = THREE.SRGBColorSpace;
        midTex.minFilter = THREE.LinearFilter;
        midTex.magFilter = THREE.LinearFilter;
        midTex.wrapS = THREE.ClampToEdgeWrapping;
        midTex.wrapT = THREE.ClampToEdgeWrapping;
        midTex.generateMipmaps = false;
        midTex.needsUpdate = true;
        // texture.colorSpace = THREE.SRGBColorSpace;
        midTex.format = THREE.RGBAFormat;
        midTex.anisotropy = this.renderer.capabilities.getMaxAnisotropy(); // für Schärfe
        mesh.material.uniforms.baseTexture.value = midTex;
        textures.push(midTex);
      } else {
        mesh.material.uniforms.baseTexture.value = highTex;
      }
      // Low


      return {
        mesh: mesh,
        textures: textures,
        activeTexture: 0
      };
    },
    downscaleCanvas(srcCanvas, maxSize) {
      let targetWidth = srcCanvas.width;
      let targetHeight = srcCanvas.height;

      if (Math.max(targetWidth, targetHeight) > maxSize) {
        const scale = maxSize / Math.max(targetWidth, targetHeight);
        targetWidth = Math.round(targetWidth * scale);
        targetHeight = Math.round(targetHeight * scale);
      }

      const dstCanvas = document.createElement("canvas");
      dstCanvas.width = targetWidth;
      dstCanvas.height = targetHeight;

      const ctx = dstCanvas.getContext("2d");
      ctx.drawImage(srcCanvas, 0, 0, targetWidth, targetHeight);

      return dstCanvas;
    },
    async integrateImagesOnMesh(mesh) {
      const promises = [];
      const wallImages = [];
      const wallNumber = parseInt(mesh.name, 10);
      const dimensions = this.annotationsByWall[wallNumber] || [];
      const height = 3072;
      const dimensionAngle = this.cave3DInfForWalls[wallNumber].dimensionAngle;
      const width = height // uvDirection === 0 ? height * Math.abs(getWidthHeightRatio3D) : Math.round(height / Math.abs(getWidthHeightRatio3D));

      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, width, height);

      const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
      svg.setAttribute("preserveAspectRatio", "xMinYMin meet");

      const g = document.createElementNS("http://www.w3.org/2000/svg", "g");
      g.setAttribute("transform", `rotate(${dimensionAngle}, ${width / 2}, ${height / 2})`);
      svg.appendChild(g);

      // Bestehende Textur verarbeiten
      const existingTexture = mesh.material.map;
      if (existingTexture?.image) {
        const img2 = document.createElement("img");
        img2.width = width;
        img2.height = height;
        if (existingTexture.image instanceof HTMLImageElement) {
          img2.src = existingTexture.image.src;
        } else if (existingTexture.image instanceof HTMLCanvasElement) {
          img2.src = existingTexture.image.toDataURL();
        } else if (existingTexture.image instanceof ImageBitmap) {
          ctx.drawImage(existingTexture.image, 0, 0, width, height);
        }
        g.appendChild(img2);
      }
      const registerPoints = []
      const parser = new DOMParser();
      const colocodeReg = []

      await buildWallCanvas(
        registerPoints,
        canvas,
        width,
        height,
        mesh.name,
        dimensions,
        this.relatedDepictions,
        this.setRegisterShaderIndex,
        colocodeReg,
        this.putInIcoDepictionShaderDic,
        this.putInDepictionShaderDic,
        this.progress,
        process.env.VUE_APP_IIIFAPI,
        (url) => this.wallCanvasIIIFImageCache[url],
        (url, image) => {
          if (image) {
            this.wallCanvasIIIFImageCache[url] = image;
          } else {
            delete this.wallCanvasIIIFImageCache[url];
          }
        }
      )

      const texture = new THREE.CanvasTexture(canvas);
      texture.flipY = !texture.flipY;
      texture.generateMipmaps = false;
      texture.colorSpace = THREE.SRGBColorSpace;
      texture.minFilter = THREE.LinearFilter;
      texture.magFilter = THREE.LinearFilter;
      texture.wrapS = THREE.ClampToEdgeWrapping;
      texture.wrapT = THREE.ClampToEdgeWrapping;
      texture.generateMipmaps = false;
      texture.needsUpdate = true;
      // texture.colorSpace = THREE.SRGBColorSpace;
      texture.format = THREE.RGBAFormat;
      texture.premultiplyAlpha = true;
      texture.anisotropy = this.renderer.capabilities.getMaxAnisotropy(); // für Schärfe
      let origEmissive = (mesh.material && mesh.material.emissive) ? mesh.material.emissive.clone() : new THREE.Color(0,0,0);
      const origEmissiveIntensity = (mesh.material && typeof mesh.material.emissiveIntensity === 'number')
        ? mesh.material.emissiveIntensity * 3
        : ((mesh.material && typeof mesh.material.emissive === 'object' && mesh.material.emissive.getHex && (mesh.material.emissive.getHex() !== 0)) ? 1.0 : 0.0);
      origEmissive = origEmissive.convertSRGBToLinear();
      const overlayShader = {
        uniforms: {
          baseTexture: { value: null },
          time: { value: 0 },
          polygonVisibility: { value: polygonVisibility },
              polygonColors: { value: polygonColors },

          // NEU hier direkt definieren:
          polyTex: { value: null },
          polySizes: { value: new Float32Array(numPolygons) },
          maxPoints: { value: 0 },
          numPolygons: { value: registerPoints.length }
        },
        vertexShader: `
          varying vec2 vUv;
          varying vec3 vWorldPos;
          varying vec3 vNormal;
          void main() {
            vUv = uv;
            vNormal = normalize(mat3(modelMatrix) * normal);
            vec4 wp = modelMatrix * vec4(position, 1.0);
            vWorldPos = wp.xyz;
            gl_Position = projectionMatrix * viewMatrix * wp;
          }
        `,
        fragmentShader: `
        precision highp float;
        precision highp int;

        #define MAX_POLY_POINTS 512

        uniform sampler2D polyMetaTex;
        uniform sampler2D baseTexture;
        uniform sampler2D polyTex;

        uniform float maxPoints;
        uniform int numPolygons;
        uniform float emissiveIntensity;
        uniform vec3 emissiveColor;
        uniform float time;

        varying vec2 vUv;
        varying vec3 vWorldPos;
        varying vec3 vNormal;
        ${NIGHT_GLSL}
        float distanceToSegment(vec2 p, vec2 a, vec2 b) {
            vec2 pa = p - a;
            vec2 ba = b - a;
            float h = clamp(dot(pa, ba) / dot(ba, ba), 0.0, 1.0);
            return length(pa - ba * h);
        }

        bool pointInPolygon(vec2 p, int polyIdx, int numPoints) {

            bool inside = false;

            for (int i = 0; i < MAX_POLY_POINTS; i++) {

                if (i >= numPoints) break;

                float fx = (float(i) + 0.5) / maxPoints;
                float fy = (float(polyIdx) + 0.5) / float(numPolygons);

                int nextIndex = i + 1;
                if (nextIndex >= numPoints) nextIndex = 0;

                float fx2 = (float(nextIndex) + 0.5) / maxPoints;

                vec2 p1 = texture2D(polyTex, vec2(fx, fy)).rg;
                vec2 p2 = texture2D(polyTex, vec2(fx2, fy)).rg;

                float denom = p2.y - p1.y;

                if (abs(denom) < 1e-7) continue;

                if (((p1.y > p.y) != (p2.y > p.y)) &&
                    (p.x < (p2.x - p1.x) * (p.y - p1.y) / denom + p1.x)) {
                    inside = !inside;
                }
            }

            return inside;
        }

        float polygonEdgeDistance(vec2 p, int polyIdx, int numPoints) {

            float minDist = 9999.0;

            for (int i = 0; i < MAX_POLY_POINTS; i++) {

                if (i >= numPoints) break;

                int nextIndex = i + 1;
                if (nextIndex >= numPoints) nextIndex = 0;

                float fx = (float(i) + 0.5) / maxPoints;
                float fy = (float(polyIdx) + 0.5) / float(numPolygons);

                float fx2 = (float(nextIndex) + 0.5) / maxPoints;

                vec2 p1 = texture2D(polyTex, vec2(fx, fy)).rg;
                vec2 p2 = texture2D(polyTex, vec2(fx2, fy)).rg;

                float d = distanceToSegment(p, p1, p2);

                minDist = min(minDist, d);
            }

            return minDist;
        }

        vec3 getMeta(int idx) {
          float v = (float(idx)+0.5)/float(numPolygons);
          vec4 meta = texture2D(polyMetaTex, vec2(0.25, v));
          return meta.rgb;
        }

        vec4 getBBox(int idx) {
          float v = (float(idx)+0.5)/float(numPolygons);
          return texture2D(polyMetaTex, vec2(0.75, v));
        }
        bool pointInBBox(vec2 p, vec4 bbox) {
            return (
                p.x >= bbox.x &&
                p.y >= bbox.y &&
                p.x <= bbox.z &&
                p.y <= bbox.w
            );
        }
        void main() {

            vec4 baseColor = texture2D(baseTexture, vUv);
            vec3 color = baseColor.rgb;

            color += emissiveColor * emissiveIntensity;
            if (lightMode > 0.5) {
              vec3 n = normalize(vNormal);
              if (!gl_FrontFacing) n = -n;
              color = nightLight(color, n, vWorldPos);
            }
            float glowWidth = 0.0;

            for (int i = 0; i < 256; i++) {

                if (i >= numPolygons) break;

                vec3 meta = getMeta(i);
                vec4 bbox = getBBox(i);
                float visible = meta.r;
                float colCode = meta.g;
                int nPoints = int(floor(meta.b + 0.5));

                if (visible < 0.5 || nPoints < 3) continue;
                if (!pointInBBox(vUv, bbox)) continue;
                bool inside = pointInPolygon(vUv, i, nPoints);

                if (inside) {

                    vec3 overlay;

                    if (colCode < 0.25) {
                        overlay = vec3(0.78125, 0.0, 0.0);

                    } else if (colCode < 0.5) {
                        overlay = vec3(0.78125, 0.5, 0.5);

                    } else if (colCode < 0.75) {
                        overlay = vec3(1.0);

                    } else if (colCode < 1.1) {

                        overlay = vec3(0.0, 0.78125, 0.0);

                        float pulse = 0.4 + 0.3 * sin(time * 3.0);
                        color = mix(color, overlay, pulse);

                    } else if (colCode < 1.6) {

                        overlay = vec3(0.5, 0.78125, 0.5);

                        float pulse = 0.6 + 0.35 * sin(time * 4.0);
                        color = mix(color, overlay, pulse);

                    } else if (colCode < 2.1) {

                        overlay = vec3(1.0);

                    } else {

                        overlay = vec3(0.0, 0.78125, 0.0);
                    }

                    color = mix(color, overlay, 0.25);
                }

                // ---------- OUTER GLOW ----------

                if (colCode > 0.9 && colCode < 2.0) {

                    float dist = polygonEdgeDistance(vUv, i, nPoints);

                    if (dist < glowWidth) {

                        float glow = 1.0 - dist / glowWidth;

                        float pulse = 0.7 + 0.3 * sin(time * 2.0);

                        vec3 glowColor = vec3(1.0, 0.9, 0.3);

                        color += glowColor * glow * pulse * 0.8;
                    }
                }
            }

            gl_FragColor = vec4(color, 1.0);
        }
        `
      };
      const maxPoints = Math.max(...registerPoints.map(p => p.length));
      const numPolygons = registerPoints.length;
      let polygonVisibility = new Float32Array(numPolygons)
      for (let i = 0; i < numPolygons; i++) {
        polygonVisibility[i] = colocodeReg[i] === 0 ? 1 : 0
      }

      let polygonColors = new Float32Array(numPolygons)
      for (let i = 0; i < numPolygons; i++) {
        polygonColors[i] = colocodeReg[i]
      }
      this.$log.debug("colocodeReg", colocodeReg, numPolygons, polygonColors, polygonVisibility, mesh.name)
      const material = new THREE.ShaderMaterial({
        uniforms: {
          time: { value: 0 },
          baseTexture: { value: null },
          polyTex: { value: null },
          polyMetaTex: { value: null },
          emissiveIntensity: { value: 6 },
          emissiveColor: { value: new THREE.Vector3(origEmissive.r, origEmissive.g, origEmissive.b) },
          maxPoints: { value: maxPoints },
          numPolygons: { value: numPolygons },
          lightMode: this._lampUniforms.lightMode,
          ambientLevel: this._lampUniforms.ambientLevel,
          lampPos: this._lampUniforms.lampPos,
          lampColor: this._lampUniforms.lampColor,
          lampIntensity: this._lampUniforms.lampIntensity,
          sunDir: this._lampUniforms.sunDir,
          sunColor: this._lampUniforms.sunColor,
          sunIntensity: this._lampUniforms.sunIntensity,
          lampRadius: this._lampUniforms.lampRadius,
        },
        vertexShader: overlayShader.vertexShader,
        fragmentShader: overlayShader.fragmentShader,
        transparent: true,
        side: THREE.DoubleSide,

      });
      //mesh.material = material;
      mesh.material = material;
      // Textur aktualisieren und Material setzen
      const polygonPoints = new Float32Array(registerPoints.length * maxPoints * 2); // UVs flattened
      const polygonLengths = new Float32Array(registerPoints.length); // Punkte pro Polygon
      registerPoints.forEach((poly, i) => {
        polygonLengths[i] = poly.length;
        poly.forEach((uv, j) => {
          polygonPoints[(i*maxPoints+j)*2+0] = uv.u;
          polygonPoints[(i*maxPoints+j)*2+1] = uv.v;
        });
      });
      const polyTex = new THREE.DataTexture(
        polygonPoints,
        maxPoints,                 // width = Punkte pro Polygon
        registerPoints.length,     // height = Anzahl Polygone
        THREE.RGFormat,
        THREE.FloatType
      );
      // numPolygons, maxPoints etc sind schon definiert
      // 1) Meta-Daten als Float32Array
      function computeBBox(points) {

        if (!points || points.length === 0) {
          return {minX:0, minY:0, maxX:0, maxY:0};
        }

        let minX = points[0].u;
        let minY = points[0].v;
        let maxX = points[0].u;
        let maxY = points[0].v;

        for (let i = 1; i < points.length; i++) {
          const p = points[i];

          if (p.u < minX) minX = p.u;
          if (p.v < minY) minY = p.v;
          if (p.u > maxX) maxX = p.u;
          if (p.v > maxY) maxY = p.v;
        }

        return {minX, minY, maxX, maxY};
      }
      const metaData = new Float32Array(numPolygons * 8); // lieber RGBA
      for (let i = 0; i < numPolygons; i++) {
        const base = i * 8;
        metaData[base+0] = polygonVisibility[i];
        metaData[base+1] = polygonColors[i];
        metaData[base+2] = polygonLengths[i];
        metaData[base+3] = 0; // padding
        const bbox = computeBBox(registerPoints[i]);
        metaData[base+4] = bbox.minX;
        metaData[base+5] = bbox.minY;
        metaData[base+6] = bbox.maxX;
        metaData[base+7] = bbox.maxY;

      }
      this.$log.debug("metaData", metaData)
      const polyMetaTex = new THREE.DataTexture(
        metaData,
        2,                       // width
        numPolygons,             // height
        THREE.RGBAFormat,
        THREE.FloatType
      );

      polyMetaTex.wrapS = THREE.ClampToEdgeWrapping;
      polyMetaTex.wrapT = THREE.ClampToEdgeWrapping;
      polyMetaTex.minFilter = THREE.NearestFilter;
      polyMetaTex.magFilter = THREE.NearestFilter;
      polyMetaTex.generateMipmaps = false;
      polyMetaTex.flipY = false;
      polyMetaTex.colorSpace = THREE.NoColorSpace;
      polyMetaTex.needsUpdate = true;
      polyTex.minFilter = THREE.NearestFilter;
      polyTex.magFilter = THREE.NearestFilter;
      polyTex.generateMipmaps = false;
      polyTex.flipY = false;
      polyTex.colorSpace = THREE.NoColorSpace;
      polyTex.needsUpdate = true;
      material.uniforms.polyMetaTex.value = polyMetaTex;
      material.uniforms.polyTex.value = polyTex;
      material.uniforms.maxPoints.value = maxPoints;
      // LOD erzeugen
      // Ins Dictionary schreiben und ins Scenegraph einsetzen
      this.wallShaderDic[mesh.name] = this.buildWallEntry(mesh, canvas, );

    },
    makeLowerResTexture(origTexture, maxSize = 256) {
      if (!origTexture?.image) return origTexture;
      const src = origTexture.image;
      const canvas = document.createElement("canvas");
      const scale = maxSize / Math.max(src.width, src.height);
      canvas.width = Math.round(src.width * scale);
      canvas.height = Math.round(src.height * scale);

      const ctx = canvas.getContext("2d");
      ctx.drawImage(src, 0, 0, canvas.width, canvas.height);

      const texture = new THREE.CanvasTexture(canvas);
      texture.colorSpace = THREE.SRGBColorSpace;
      texture.minFilter = THREE.LinearFilter;
      texture.magFilter = THREE.LinearFilter;
      texture.flipY = false;
      texture.needsUpdate = true;
      return texture;
    },

    // Funktion, um eine Textur aus einem Mesh zu bekommen
    getWorldPositionFromUV(mesh, uvX, uvY) {
      const geometry = mesh.geometry;
      geometry.computeBoundingBox();
      const bbox = geometry.boundingBox;

      const size = new THREE.Vector3();
      bbox.getSize(size);

      const min = bbox.min;

      // Position im lokalen Koordinatensystem
      const localX = min.x + uvX * size.x;
      const localY = min.y + (1 - uvY) * size.y; // ggf. Y invertieren!
      const localZ = 0;

      const localPos = new THREE.Vector3(localX, localY, localZ);

      // Umrechnen in Weltkoordinaten
      return mesh.localToWorld(localPos);
    },

    resetToInitialPosition(){
      this.touchQuaternion = new THREE.Quaternion();
    },
    onWindowResize() {
      if (this.currentCamera){
        this.currentCamera.aspect = document.getElementById(this.elementID).offsetWidth / document.getElementById(this.elementID).offsetHeight;
        this.currentCamera.updateProjectionMatrix();
        this.renderer.setSize(document.getElementById(this.elementID).offsetWidth, document.getElementById(this.elementID).offsetHeight );
        this.renderer.outputColorSpace = THREE.SRGBColorSpace;
        const width = document.getElementById(document._self.elementID).offsetWidth;
        const height = document.getElementById(document._self.elementID).offsetHeight;
        this.renderer.setPixelRatio(width / height);
      }
    },
    getAllMashes(mashes, cave3dObject){
      if (cave3dObject.isMesh === true && !cave3dObject.userData.vrMenu) {
        mashes.push(cave3dObject)
      }
      if (cave3dObject.children){
        for (const child of cave3dObject.children){
          mashes = this.getAllMashes(mashes, child)
        }
      }
      return mashes
    },
    calculateDistance(touch1, touch2) {
      const dx = touch1.pageX - touch2.pageX;
      const dy = touch1.pageY - touch2.pageY;
      return Math.sqrt(dx * dx + dy * dy);
    },
    onTouchStart(event) {

      if (event.touches.length === 1) {
        this.isDragging = true
        this.lastTouchX = event.touches[0].pageX
        this.lastTouchY = event.touches[0].pageY

      }
      if (event.touches.length === 2) {

        this.isDragging = false
        this.isZooming = true

        this.initialDistance = this.calculateDistance(
          event.touches[0],
          event.touches[1]
        )

      }
    },
    onTouchMove(event) {
      if (this.isDragging && event.touches.length === 1) {
          const x = event.touches[0].clientX
          const y = event.touches[0].clientY

          const movementX = x - this.lastTouchX
          const movementY = y - this.lastTouchY

          this.lastTouchX = x
          this.lastTouchY = y

          const euler = new THREE.Euler(0,0,0,'YXZ')

          euler.setFromQuaternion(this.currentCamera.quaternion)

          euler.y -= movementX * 0.003
          euler.x -= movementY * 0.003

          euler.x = Math.max(-Math.PI/2, Math.min(Math.PI/2, euler.x))

          this.currentCamera.quaternion.setFromEuler(euler)
      }
      if (this.isZooming && event.touches.length === 2) {
            const distance = this.calculateDistance(
          event.touches[0],
          event.touches[1]
        )

        const delta = distance - this.initialDistance

        const speed = 0.01

        const dir = new THREE.Vector3()
        this.currentCamera.getWorldDirection(dir)

        this.currentCamera.position.addScaledVector(dir, delta * speed)

        this.initialDistance = distance

      }

    },
    onTouchEnd(event) {
      if (event.touches.length < 2) {
        this.isZooming = false
        this.initialDistance = null
      }

      if (event.touches.length === 0) {
        this.isDragging = false
      }

    },
    moveCameraIfNoCollision(camera, moveDistance, direction)  {
      const raycaster = new THREE.Raycaster();
      const lookDirection = new THREE.Vector3();
      const sideDirection = new THREE.Vector3();
      const up = new THREE.Vector3(0, 1, 0);

      if (direction === 'forward' || direction === 'backward') {
        camera.getWorldDirection(lookDirection);
        if (direction === 'backward') {
          lookDirection.negate().normalize();
        }
      } else if (direction === 'left' || direction === 'right') {
        camera.getWorldDirection(lookDirection);
        sideDirection.crossVectors(up, lookDirection).normalize();
        if (direction !== 'left') {
          sideDirection.negate().normalize();
        }
        lookDirection.copy(sideDirection);
      }
      const targetPosition = camera.position.clone().addScaledVector(lookDirection, moveDistance);
      raycaster.set(camera.position, targetPosition.clone().sub(camera.position).normalize());
      raycaster.far = moveDistance;

      const allMashes = this.getAllMashes([], this.scene)

      const collisionObjects = raycaster.intersectObjects(allMashes);
      // const collisionObjects = intersects.filter(intersectedObject => intersectedObject.object.type !== "GridHelper");

      if (collisionObjects.length === 0) {
        this.$log.debug("movin cam")
        camera.position.copy(targetPosition);
      } else {
        console.log("collision!!", collisionObjects);
      }
    },

    isMobile() {
      return isMobile()
    },
    getRootWall(wall){
      if (wall.parentID === 0){
        return wall
      } else {
        return this.getRootWall(getWallByID(wall.parentID, this.$store.state.wallLocation))
      }
    },
    getPolygonCenter(polygon) {
      let minX = Infinity, minY = Infinity;
      let maxX = -Infinity, maxY = -Infinity;

      polygon.forEach(p => {
        minX = Math.min(minX, p[0]);
        minY = Math.min(minY, p[1]);
        maxX = Math.max(maxX, p[0]);
        maxY = Math.max(maxY, p[1]);
      });

      return {
        x: (minX + maxX) / 2,
        y: (minY + maxY) / 2
      };
    },
    getWorldPointFromUV(mesh, uv) {

      // UV in lokale Plane-Koordinaten schätzen
      // funktioniert, weil Wandtexturen planar projiziert sind

      mesh.geometry.computeBoundingBox();

      const bbox = mesh.geometry.boundingBox;
      const size = bbox.getSize(new THREE.Vector3());
      const center = bbox.getCenter(new THREE.Vector3());

      // lokale Position schätzen
      const localX = center.x + (uv.x - 0.5) * size.x;
      const localY = center.y + (uv.y - 0.5) * size.y;

      const localPoint = new THREE.Vector3(localX, localY, center.z);

      const worldPoint = mesh.localToWorld(localPoint.clone());


      // Raycast entlang der Wandnormalen für präzisen Treffer
      const normal = new THREE.Vector3(0, 0, 1)
        .applyQuaternion(mesh.quaternion)
        .normalize();

      const raycaster = new THREE.Raycaster(
        worldPoint.clone().addScaledVector(normal, 1),
        normal.clone().negate()
      );

      const hits = raycaster.intersectObject(mesh, true);

      if (hits.length) {
        return hits[0].point;
      }

      return worldPoint;
    },

    focusCameraOnAnnotation(annotation, wallMesh) {

      // SVG parsen
      const svgString = annotation.target.selector.value;
      const polygons = parseSvgSelector(svgString);
      this.$log.debug("depiction for focus polygons", polygons)
      if (!polygons.length) return;

      // Mittelpunkt Polygon (Texture space)
      const center = this.getPolygonCenter(polygons[0]);
      this.$log.debug("depiction for focus center", center)
      // Texturepixel → UV
      const uv = new THREE.Vector2(
        center.x / 3072,
        center.y / 3072
      );

      this.$log.debug("depiction for focus uv", uv)

      // UV → Ray auf Mesh
      wallMesh.updateMatrixWorld(true);
      const worldPoint = this.getWorldPointFromUV(wallMesh, uv);

      if (!worldPoint) return;
      this.visualizeWorldPoint(worldPoint);
      // Kamera ausrichten
      //this.camera.lookAt(worldPoint);
      this.$log.debug("depiction for focus worldPoint", worldPoint)
      this.currentCamera.lookAt(worldPoint);
      //this.controls.target.copy(worldPoint);
      this.controls.update();
    },
    findAnnotationByRegister(reg, no, dimensions, dimensionId = null) {
      this.$log.debug("depiction for focus findAnnotationByRegister", reg, no, dimensions, dimensionId);
      for (const dimension of dimensions){

        for (const anno of dimension) {
          this.$log.debug("depiction for focus anno", anno)
          if (!anno.body || !anno.body.length) continue;

          try {
            const meta = JSON.parse(anno.body[0].value);

            if (meta.Reg == reg && meta.No == no && (dimensionId == null || String(meta.dimensionId) === String(dimensionId))) {
              return anno;
            }
          } catch (e) {
            console.warn("depiction for focus Invalid JSON in annotation body", anno);
          }
        }
      }
      return null;
    },
    getAnnotationByRegNo(reg, no, wallNumber, dimensionId = null) {
      const dimensions = this.annotationsByWall[wallNumber] || [];
      this.$log.debug("depiction for focus getAnnotationByRegNo", reg, no, dimensions, dimensionId);
      for (const dimension of dimensions) {
        for (const anno of dimension) {
          if (!anno.body?.length) continue;

          try {
            const meta = JSON.parse(anno.body[0].value);

            if (
              meta.Reg === String(reg) &&
              meta.No === String(no) &&
              (dimensionId == null || String(meta.dimensionId) === String(dimensionId))
            ) {
              return anno;
            }
          } catch {}
        }
      }
      return null;
    },

    async init3DModel(gltf){
      // Go through each child in the object
      for (var i = gltf.scene.children.length - 1; i >= 0; i--) {
        var child = gltf.scene.children[i];
        if (child.isLight) {
          gltf.scene.children.splice(i, 1); // Entfernt das Licht-Objekt
        } else {
        }
      }
      console.log("loaded model", gltf, );  const meshesToProcess = [];
      this.progress.visible = true;
      this.progress.total = 0;
      gltf.scene.traverse((child) => {
        if (child.isMesh && child.material) {
          const wallNumber = parseInt(child.name, 10);
          const dimensions = this.annotationsByWall[wallNumber];
          child.material.emissiveIntensity = 0.3;
          if (dimensions && dimensions.length > 0) {
            meshesToProcess.push(child);
            for (const dimension of dimensions) {
              this.progress.total += dimension.length;
            }
          } else {
            this.$log.debug("no dimensions for mesh", child.material.map.image);
          }
        }
      });
      this.shaderCount = meshesToProcess.length
      for (const child of meshesToProcess) {
        await this.integrateImagesOnMesh(child);
      }

      this.progress.visible = false;

      const _self = this
      let cameraDic = {}
      gltf.cameras.forEach(function(camera) {
        cameraDic[camera.name] = camera
        if (camera.name === "102") {
          _self.currentCamera = camera
          cameraDic[camera.name] = camera.clone()
        }
      })
      if (!this.currentCamera){
        const firstKey = Object.keys(cameraDic)[0]
        this.camera = cameraDic[firstKey]
        this.currentCamera = this.camera
      } else {
        this.camera = cameraDic[this.currentCamera.name]
      }
      this.switchCamera(this.camera)
      this.cameraDic = cameraDic
      // this.currentCamera = gltf.cameras[gltf.cameras.length - 4]
      if (this.fokusOnFirstDepiction){
        const depiction = this.item.depictionID? this.item : this.relatedDepictions[0]
        for (const wall of this.cave.wallList){
          for (const wde of wall.wallDimensions){
            for (const ce of wde.coordinates){
              if (depiction){
                if (ce.depictionID === depiction.depictionID){
                  let wallTree = getWallByID(wall.wallLocationID, this.$store.state.wallLocation)
                  this.camera = this.cameraDic[this.getRootWall(wallTree).wallLocationID.toString()]
                  this.focusCoordinate = {
                    "wallLocationID": wall.wallLocationID,
                    "ce": ce,
                    "dimensionId": wde.wallDimensionID
                  }
                  break
                }

              } else {
                  let wallTree = getWallByID(wall.wallLocationID, this.$store.state.wallLocation)
                  this.camera = this.cameraDic[this.getRootWall(wallTree).wallLocationID.toString()]
                  this.focusCoordinate = {
                    "wallLocationID": wall.wallLocationID,
                    "ce": ce,
                    "dimensionId": wde.wallDimensionID
                  }
                  this.$log.debug("depiction for focus focusCoordinate", this.focusCoordinate);
                  break
              }
            }
          }
        }
      } else {
        this.camera = this.cameraDic["102"]
      }
      if (this.currentCamera && document.getElementById(this.elementID)){
        this.currentCamera.aspect = (document.getElementById(this.elementID).offsetWidth, document.getElementById(this.elementID).offsetHeight);
      }
      this.controls = new PointerLockControls(this.currentCamera, this.renderer.domElement);
      this.controls.enabled = false
      this.controls.minDistance = -10
      this.renderer.domElement.addEventListener('webglcontextlost', function(event) {
        event.preventDefault();
        this.info = 'WebGL context lost';
      }, false);

      this.renderer.domElement.addEventListener('webglcontextrestored', function() {
        this.info = 'WebGL context restored';
        // Neu laden der Texturen und der Szene
      }, false);
      const userAgent = navigator.userAgent.toLowerCase();
      const isFirefox = userAgent.includes('firefox');
      const isMobile = userAgent.includes('mobi');
      document.getElementById(this.elementID).addEventListener('touchmove', this.onTouchMove, { passive: false });
      document.getElementById(this.elementID).addEventListener('touchend', this.onTouchEnd);
      document.getElementById(this.elementID).addEventListener('touchstart', this.onTouchStart);
      console.log("isMobile", isMobile, "isFirefox", isFirefox);
      if (isMobile){
        if (this.motionControllOn){
          if (window.DeviceMotionEvent){
            if (typeof window.DeviceMotionEvent.requestPermission !== 'undefined' && typeof window.DeviceMotionEvent.requestPermission === 'function') {
              this.requestDeviceMotion = true
            } else {
              console.log("device motion activated!");
              window.addEventListener('deviceorientation', this.handleOrientation);
            }
          } else {
            console.log("device motion activated!");
            window.addEventListener('deviceorientation', this.handleOrientation);
          }
        }
      }
      // }
      // window.addEventListener('devicemotion', this.handleMotion, true);


      document.getElementById(this.elementID).addEventListener( 'wheel', function (event) {
        if (_self.controls.enabled){
          event.preventDefault();
          const lookDirection = new THREE.Vector3();
          _self.currentCamera.getWorldDirection(lookDirection);
          if (event.wheelDelta < 0){
            _self.moveCameraIfNoCollision(_self.currentCamera, 0.01, false);
          } else if (event.wheelDelta > 0){
            _self.moveCameraIfNoCollision(_self.currentCamera, 0.01, true);

          }
          _self.currentCamera.updateProjectionMatrix();
          _self.onWindowResize()
        }
      }, false );
      document.addEventListener( 'keyup', function (event) {

        if (_self.controls.isLocked){
          event.preventDefault();
          event.stopPropagation()
          _self.keysPressed.delete(event.key);
          // const lookDirection = new THREE.Vector3();
          // _self.currentCamera.getWorldDirection(lookDirection);
          // if (event.key === "ArrowUp"){
          //   _self.moveCameraIfNoCollision(_self.currentCamera, 0.01, false);
          // } else if (event.key  === "ArrowDown"){
          //   _self.moveCameraIfNoCollision(_self.currentCamera, 0.01, true);
          // }
          // _self.currentCamera.updateProjectionMatrix();
          // _self.onWindowResize()
        } else {
          if (event.key === "Escape" && _self.fullScreen){
            document.getElementById("button3").click();
          }
        }
      }, false );
      document.addEventListener( 'keydown', function (event) {
        if (_self.controls.isLocked){
          event.preventDefault();
          event.stopPropagation()
          _self.keysPressed.add(event.key);
        }
      }, false );
      document.getElementById(this.elementID).addEventListener('click', function (event) {

        if (!_self.hasTouch()){

          _self.controls.lock();
        }
      });
      this.orbitControls = new OrbitControls(this.currentCamera, this.renderer.domElement);
      this.orbitControls.enabled = true
      this.orbitControls.minPolarAngle = 0; // Restrict to look above
      this.orbitControls.maxPolarAngle = Math.PI / 2; // Restrict to look horizontal, not below
      this.orbitControls.update();
      this.scene.add(gltf.scene)
      this.cave3DModel = gltf;
      document.addEventListener('fullscreenchange', () => {
        _self.fullScreen = !_self.fullScreen;
        const tooltip = document.getElementById("controls");
        if (_self.fullScree) {

          document.body.appendChild(tooltip);
          tooltip.style.position = 'absolute';
          tooltip.style.zIndex = '9999'; // Ensure it's above other elements
        } else {
          // Restore tooltip to its original container
          const originalParent = document.getElementById('original-parent-id'); // Adjust as needed
          if (originalParent) {
            tooltip.style.position = 'relative';
            tooltip.style.zIndex = '4';
            originalParent.appendChild(tooltip);
          }
        }
      });
      // this.saveModel(this.cave3DModel.scene, "scene.glb")
      if (this.focusCoordinate){
        const anno = this.getAnnotationByRegNo(
          this.focusCoordinate.ce.register,
          this.focusCoordinate.ce.number,
          this.focusCoordinate.wallLocationID,
          this.focusCoordinate.dimensionId
        );
        const wallMesh = this.wallShaderDic[this.focusCoordinate.wallLocationID]?.mesh;
        this.focusCameraOnAnnotation(anno, wallMesh);
        wallMesh.material.needsUpdate = true;
        this.initHighligtAnno()
      } else {
        this.currentCamera.rotation.x = 0;
        this.currentCamera.rotation.z = 0;
      }
      this.animate = this.animate.bind(this);
      this.animate();
    },
    visualizeWorldPoint(point) {

      // Alte Markierung entfernen


      const geometry = new THREE.SphereGeometry(0.05, 16, 16);
      const material = new THREE.MeshBasicMaterial({
        color: 0xff0000,
        depthTest: false
      });
    },
    getOptimalTextureSize() {
      const caps = this.renderer.capabilities;
      const maxHW = caps.maxTextureSize;
      const maxUnits = caps.maxTextures;
      let limit = 1024;
      // Nur die "teuren" Shader-Meshes zählen
      const shaderCount = this.shaderCount;

      const budget = maxHW * maxUnits;
      this.$log.info("maxHW", maxHW, "maxUnits", maxUnits, "budget", budget, "shaderCount", shaderCount);
      if (shaderCount * 3072 <= budget) {
        limit = 3072;
      } else if (shaderCount * 2048 <= budget) {
        limit = 2048;
      } else {
        limit = 1024;
      }

      return limit;
    },
    async prepareInitCave3dModelViewer(){
      for (const wall of this.cave.wallList){
        this.cave3DInfForWalls[wall.wallLocationID] = {
          "dimensionAngle": wall.dimensionAngle,
          "getWidthHeightRatio3D": wall.widthHeightRatio3D,
          "uvDirection": wall.uvDirection
        }
        let wallMapList = []
        for (const wde of wall.wallDimensions){
          let depictionDic = {}
          for (const ce of wde.coordinates){
            if (!(ce.register in depictionDic)){
              depictionDic[ce.register] = {}
            }
            if (!(ce.number in depictionDic[ce.register])){
              depictionDic[ce.register][ce.number] = []
            }
            const depiction = this.relatedDepictions.find(depiction => depiction.depictionID === ce.depictionID)
            this.$log.debug("depiction", depiction)
            let masterAnnotation
            if (depiction){
              masterAnnotation = depiction.relatedAnnotationList?.find(annotation => annotation.annotoriousID === depiction.masterAnnotation)
            }
            this.$log.debug("coordinates", ce, ce.depictionID)
            depictionDic[ce.register][ce.number].push({"depictionID": ce.depictionID, "depictionText": ce.name, "depictionExact": ce.exact, "masterAnnotation": masterAnnotation?.w3c, "imageTransform": ce.imageTransform});
          }
          const wallMap = createMap(depictionDic, wde, "wallDimensionentry" + wde.wallDimensionID)
          wallMapList.push(wallMap)
        }
        this.annotationsByWall[wall.wallLocationID] = wallMapList
      }
      if (this.scene){
        while (this.scene.children.length > 0){
          this.scene.remove(this.scene.children[0]);
        }
      } else {
        this.scene = new THREE.Scene();
      }
      if (this.renderer){
        this.renderer.clear();
      } else {
        this.renderer = new THREE.WebGLRenderer({ antialias: !isMobile(), powerPreference: 'high-performance', alpha: false });
        if (isMobile()){
          const maxDPR = isMobile() ? 1 : 2; // auf Handy: 1

        }
        const width = document.getElementById(document._self.elementID).offsetWidth;
        const height = document.getElementById(document._self.elementID).offsetHeight;
        this.renderer.setPixelRatio(width / height);        this.renderer.shadowMap.enabled = !isMobile;
        this.renderer.outputColorSpace = THREE.SRGBColorSpace;
        this.renderer.toneMappingExposure = 1.0;
        this.renderer.toneMapping = THREE.ACESFilmicToneMapping; // oder NoToneMapping
        this.renderer.domElement.addEventListener('mousemove', this.onMouseMove);
        this.renderer.domElement.addEventListener('contextmenu', this.onMouseClick);
        document.getElementById(this.elementID).appendChild(this.renderer.domElement);
      }
      this.renderer.setSize(document.getElementById(this.elementID).offsetWidth, document.getElementById(this.elementID).offsetHeight);
      this.scene.background = new THREE.Color( 0xffffff );


      // Create the ground plane
      const planeGeometry = new THREE.PlaneGeometry(10, 10);
      const planeMaterial = new THREE.MeshLambertMaterial({ color: 0xcccccc });
      const plane = new THREE.Mesh(planeGeometry, planeMaterial);
      plane.rotation.x = -Math.PI / 2; // Rotate the plane to be horizontal
      plane.position.y -= 0.0001
      this.scene.add(plane);
      let grid = new THREE.GridHelper(10, 20, 0x000000, 0xffffff);
      plane.position.y -= 0.00001 // Slightly above the ground to avoid z-fighting
      grid.material.opacity = 0.2;
      grid.material.transparent = true;
      grid.material.opacity = 1.0; // falls Alpha-Kanal korrekt genutzt werden soll

      this.scene.add(grid);
      let light = new THREE.AmbientLight(0xffffff, 0.5);
      this.scene.add(light);
      let light3 = new THREE.PointLight(0xffffff, 1);
      this.scene.add(light3);
      this.scene.environment = null;
      let loader = new GLTFLoader();
      if (this.cave3DModel){
        await this.init3DModel(this.cave3DModel)

        this.enablePointControllsMobile()
      } else {
        const _self = this
        loader.load(
          (window.location.origin.includes("test") ? process.env.VUE_APP_USERREG : process.env.VUE_APP_USERREG )+ "resource?cave3DModelID=" + this.cave.cave3DModel.cave3DModelID,
          function (gltf) {
            _self.init3DModel(gltf)
          },
          function (xhr) {
            console.log((xhr.loaded / xhr.total * 100) + '% loaded', xhr);
          },
          function (error) {
            console.log('An error happened', error);
          }
        );
      }
    },
    requestFullScreen(event){
      event.stopPropagation()
      console.log("requesting fullscreen", document._self);

      event.preventDefault()
      var canvas = document.getElementById(document._self.elementID);
      // const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement
      console.log("fullscreen", document.getElementById(document._self.elementID));

      if (!document._self.fullScreen){
        if (canvas.requestFullscreen) {
          canvas.requestFullscreen();
        } else if (canvas.mozRequestFullScreen) {
          canvas.mozRequestFullScreen();
        } else if (canvas.webkitRequestFullscreen) {
          canvas.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
        } else if (canvas.msRequestFullscreen) {
          canvas.msRequestFullscreen();
        } else if (canvas.webkitEnterFullScreen) {
          canvas.webkitEnterFullScreen(Element.ALLOW_KEYBOARD_INPUT);
        } else {
          document.documentElement.style.overflow = 'hidden'; // Deaktiviere Scrollen in Safari
          document.body.style.overflow = 'hidden'; // Auch auf dem body
          canvas.classList.add("fullscreen-div");
          const width = window.innerWidth; // Neuer Fullscreen-Viewport
          const height = window.innerHeight;
        }

        // Renderer aktualisieren
        document._self.renderer.setSize(width, height);
        document._self.renderer.setPixelRatio(width/height);
        // }

      } else {
        document.documentElement.style.overflow = 'auto';
        document.body.style.overflow = 'auto';
        canvas.classList.remove("fullscreen-div");
        const width = document.getElementById(document._self.elementID).offsetWidth;
        const height = document.getElementById(document._self.elementID).offsetHeight;

        // Renderer aktualisieren
        document._self.renderer.setSize(width, height);
        document._self.renderer.setPixelRatio(width / height);
        // document.exitFullscreen()
      }
      document._self.renderer.setSize(document._self.renderer.domElement.clientWidth, document._self.renderer.domElement.clientHeight);
      if (document._self.renderer.renderer3D) {
        document._self.renderer.renderer3D.setSize(document._self.renderer.domElement.clientWidth, document._self.renderer.domElement.clientHeight);
      }
      if (document._self.renderer.composer) {
        document._self.renderer.composer.setSize(document._self.renderer.domElement.clientWidth, document._self.renderer.domElement.clientHeight);
      }
      document._self.fullScreen = !document._self.fullScreen
    },
    onMouseClick(event){
      event.preventDefault()
      event.stopPropagation()
      if (this.controls){
        if (!this.controls.isLocked){
          this.hoveredAnnoLocked = !this.hoveredAnnoLocked
        }

      }
    },
findRegisterByIntersection(intersects) {
  // nur Wand-Meshes mit Shader-Eintrag betrachten
  const intersect = intersects.find(i =>
    i.object.isMesh && this.wallShaderDic[i.object.name]
  );
  if (!intersect || !intersect.uv) return null;

  const entry = this.wallShaderDic[intersect.object.name];
  const texture = intersect.object.material?.uniforms?.baseTexture?.value;
  if (!texture) return null;

  let uv = intersect.uv.clone();
  if (texture.repeat) {
    if (texture.repeat.x < 0) uv.x = 1 - uv.x;
    if (texture.repeat.y < 0) uv.y = 1 - uv.y;
  }

  const wallInfo = this.cave3DInfForWalls[parseInt(intersect.object.name, 10)];
  const angle = wallInfo ? wallInfo["dimensionAngle"] : 0;
  if (angle !== 0) {
    const r = angle * Math.PI / 180;
    uv.x -= 0.5; uv.y -= 0.5;
    const rx = uv.x * Math.cos(r) - uv.y * Math.sin(r);
    const ry = uv.x * Math.sin(r) + uv.y * Math.cos(r);
    uv.x = rx + 0.5; uv.y = ry + 0.5;
  }

  const x = uv.x * entry.textures[0].image.width;
  const y = uv.y * entry.textures[0].image.height;
  return this.findRegisterAtPosition(x, y, intersect.object);
},
    onMouseMove(event) {
      // this.$emit("mousemove", event)
      if (this.currentCamera && !this.controls.isLocked && !this.hoveredAnnoLocked && !this.item.depictionID) {
        const rect = this.renderer.domElement.getBoundingClientRect();
        const mouse = new THREE.Vector2();
        mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
        mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
        const rect3D = document.getElementById(this.elementID).getBoundingClientRect()
        this.updateTooltipPosition(event)
        const raycaster = new THREE.Raycaster();
        raycaster.setFromCamera(mouse, this.currentCamera);

        const intersects = raycaster.intersectObjects(this.scene.children.find(groupObject => groupObject.type === "Group").children);
        // Filter out objects that aren't walls or relevant objects
        const intersectedWalls = intersects.filter(intersect => intersect.object.isMesh === true);
        const register = this.findRegisterByIntersection(intersectedWalls)

        if (register) {
          this.hoveredAnno = JSON.parse(register.body[0].value)
          if (this.hoveredAnno?.Depiction?.length > 0) {
            this.hoveredRegister = {
              wall: intersectedWalls[0].object.name,
              register: register,
              dimensionId: this.hoveredAnno.dimensionId
            }
            const hoveredDepiction = this.relatedDepictions.find(depiction => depiction.depictionID === this.hoveredAnno.Depiction[0].depictionID)
            //this.selectedDepictions = this.hoveredAnno.Depiction.map(depiction => depiction.depictionID)
              const ids = new Set()

            // direkte Iconography
            if (hoveredDepiction?.relatedIconographyList) {
              hoveredDepiction.relatedIconographyList.forEach(icono => {
                if (icono?.iconographyID) {
                  ids.add(icono.iconographyID)
                }
              })

            }

            // Annotation → tags → Iconography
            if (hoveredDepiction?.relatedAnnotationList) {
              hoveredDepiction.relatedAnnotationList.forEach(anno => {
                anno.tags?.forEach(tag => {
                  if (tag?.iconographyID) {
                    ids.add(tag.iconographyID)
                  }
                })
              })

            }
            this.hoveredIcos = Array.from(ids)
            this.showOverlay(register, event.clientX, event.clientY);

          } else {
            this.hideOverlay();
          }
        } else {
          this.hideOverlay();
        }
      } else {
        if (!this.hoveredAnnoLocked){
        this.hideOverlay();
        }
      }

    },
    resetAnnotations() {
      for (const wallName in this.wallShaderDic) {
        const mesh = this.wallShaderDic[wallName].mesh;
        const mat = mesh.material;
        if (mat?.uniforms?.polyMetaTex) {
          const data = mat.uniforms.polyMetaTex.value.image.data;
          const numPolygons = mat.uniforms.numPolygons.value;

          for (let i = 0; i < numPolygons; i++) {
            const base = i * 8;
            if (data[base + 1] > 0.9 && data[base + 1] < 1.1) {  // grüne Annotations zurücksetzen
              data[base] = 0.0;            // sichtbar → unsichtbar
            }
            if (data[base + 1] > 0 && data[base + 1] < 0.5) {  // rote hervorgehobene register hervorhebung entfernen 0.5 --> 0
              data[base+1] = 0;
            }
            if (data[base + 1] > 1 && data[base + 1] < 1.5) {  // grüne hervorgehobene register hervorhebung entfernen 1.5 --> 1
              data[base+1] = 1;
              data[base] = 0.0;            // sichtbar → unsichtbar
            }
            if (data[base + 1] > 1 && data[base + 1] < 2.1) {  // weiße hervorgehobene register hervorhebung entfernen 1.5 --> 1
              data[base+1] = 1;
              data[base] = 0.0;            // sichtbar → unsichtbar
            }
          }
          mat.uniforms.polyMetaTex.value.needsUpdate = true;
        }
      }
    },
    putInIcoDepictionShaderDic(wallNumber, registerPoints, depiction, anotherAnno) {
      for (const tag of anotherAnno.tags){
        if (this.IcoDepictionShaderDic[tag.iconographyID]){
          if (this.IcoDepictionShaderDic[tag.iconographyID][depiction.depictionID]) {
            if (this.IcoDepictionShaderDic[tag.iconographyID][depiction.depictionID][String(wallNumber).padStart(3, '0')]) {
              this.IcoDepictionShaderDic[tag.iconographyID][depiction.depictionID][String(wallNumber).padStart(3, '0')].push(registerPoints.length - 1)
            } else {
              this.IcoDepictionShaderDic[tag.iconographyID][depiction.depictionID][String(wallNumber).padStart(3, '0')] = [registerPoints.length - 1]
            }
          } else {
            this.IcoDepictionShaderDic[tag.iconographyID][depiction.depictionID] = {}
            this.IcoDepictionShaderDic[tag.iconographyID][depiction.depictionID][String(wallNumber).padStart(3, '0')] = [registerPoints.length - 1]
          }

        } else {
          this.IcoDepictionShaderDic[tag.iconographyID] = {}
          this.IcoDepictionShaderDic[tag.iconographyID][depiction.depictionID] = {}
          this.IcoDepictionShaderDic[tag.iconographyID][depiction.depictionID][String(wallNumber).padStart(3, '0')] = [registerPoints.length - 1]
        }
      }
    },

    findRegisterAtPosition(x, y, object) {
      // Finde die Annotation basierend auf der Position auf der Textur
      const wallNumber = parseInt(object.name, 10);
      const dimensions = this.annotationsByWall[wallNumber] || [];
      for (const dimension of dimensions){
        for (const register of dimension) {
          if (!register.body[0].value.includes("\"Reg\": \"-1\", \"No\": \"-1\"")){
            const { selector } = register.target;
            if (selector.type === "SvgSelector") {
              const polygons = parseSvgSelector(selector.value);
              for (const polygon of polygons) {
                if (this.isPointInPolygon(x, y, polygon)) {
                  return register;
                }
              }
            } else {
              const dimensions = selector.value.split(':')[1].split(',').map(parseFloat);
              const [rectX, rectY, rectWidth, rectHeight] = dimensions;
              if (x >= rectX && x <= rectX + rectWidth && y >= rectY && y <= rectY + rectHeight) {
                return register;
              }
            }
          }
        }
      }
      return null;
    },

    prepLocationAggs(){
      let locationDic = {}
      this.locationFacets = []
      for (let pr of this.relatedDepictions){
        let included = false
        if (this.selectedDepictions.length > 0){
          if (this.selectedDepictions.includes(pr.depictionID)) {
            included = true
          }
        } else {
          included = true
        }
        if (included){
          if (pr.location){
            let locationID = parseInt(pr.location.locationID, 10)
            if (locationDic[locationID]){
              locationDic[locationID] += 1
            } else {
              locationDic[locationID] = 1
            }
          }
        }
      }
      for (const [key, value] of Object.entries(locationDic)) {
        this.locationFacets.push({ "doc_count": value, "key": parseInt(key, 10) })
      }
    },
    isPointInPolygon(x, y, polygon) {
      let inside = false;
      for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        const xi = polygon[i][0]
        const yi = polygon[i][1];
        const xj = polygon[j][0]
        const yj = polygon[j][1];

        const intersect = ((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
        if (intersect) inside = !inside;
      }
      return inside;
    },

    showOverlay(register, x, y) {

      this.showTag = true
    },
    hideOverlayByClick(event){
      console.log("hideOverlayByClick:", event);
      this.showTag = false
      this.hoveredAnnoLocked = false

    },
    hideOverlay() {
      this.hoveredIcos = []
      this.hoveredRegister = null
      this.hoveredAnno = {}
      this.showTag = false
    },
    getTooltipSize () {
      var _self = this
      this.$nextTick(() => {
        const tooltipEl =
          _self.$refs.tooltip?.$children[0]?.$el

        if (!tooltipEl) return

        _self.tooltipWidth = tooltipEl.offsetWidth
        _self.tooltipHeight = tooltipEl.offsetHeight
      })
    },
    putInDepictionShaderDic(depictionInfo, meshName, length) {
        if (this.depictionShaderDic){
          if (!this.depictionShaderDic[depictionInfo.depictionID]) {
            this.depictionShaderDic[depictionInfo.depictionID] = []
          }
          this.depictionShaderDic[depictionInfo.depictionID].push({
            pos: length,
            mesh: meshName
          })
        }
    },
    updateTooltipPosition (event) {
      const container = document.getElementById(this.elementID)
      const rect = container.getBoundingClientRect()

      const mouseX = event.clientX - rect.left
      const mouseY = event.clientY - rect.top

      const offset = 50
      const margin = 20

      let x
      let y

      /* ============================
      * HORIZONTAL
      * ============================ */
      const fitsRight =
        mouseX + offset + this.tooltipWidth <= rect.width - margin

      if (fitsRight) {
        // normal: rechts vom Cursor
        x = mouseX + offset
      } else {
        // 🔁 Wechsel: links vom Cursor
        x = mouseX - this.tooltipWidth - offset
      }

      /* ============================
      * VERTICAL
      * ============================ */

      const fitsBelow =
        mouseY + this.tooltipHeight + offset <= rect.height - margin

      if (fitsBelow) {
        y = mouseY + offset
      } else {
        // 🔁 nach oben
        y = mouseY - this.tooltipHeight - offset
      }

      /* ============================
      * Sicherheits-Clamp
      * ============================ */

      this.xTag = Math.max(margin, x)
      this.yTag = Math.max(margin, y)
    },
    initHighligtAnno() {
      this.$log.debug("initHighligtAnno", this.icoSelected)
      this.resetAnnotations();
      const meshes = new Set();
      var icoMatches = null
      for (const depiction of this.selectedDepictions) {
        icoMatches = []
        for (const ico of this.icoSelected) {
          if (this.IcoDepictionShaderDic[ico.iconographyID]){
            if (this.IcoDepictionShaderDic[ico.iconographyID][depiction]) {
              icoMatches.push(this.IcoDepictionShaderDic[ico.iconographyID][depiction])
            }
          }
        }
        const shaderInfos = this.depictionShaderDic[depiction];
        if (shaderInfos) {
          for (const shaderInfo of shaderInfos) {
            var shaderEntry = this.wallShaderDic[shaderInfo.mesh];
            if (icoMatches.length > 0) {
              for (const icoMatch of icoMatches) {
                if (depiction === 175) this.$log.debug("icoMatch rect", icoMatch, shaderInfo.mesh, shaderInfo.pos, this.IcoDepictionShaderDic)
                if (icoMatch[shaderInfo.mesh]) {
                  shaderInfo.pos = icoMatch[shaderInfo.mesh]
                }
                const mesh = shaderEntry.mesh;
                const mat = mesh.material;
                if (mat?.uniforms?.polyMetaTex) {
                  const data = mat.uniforms.polyMetaTex.value.image.data;
                  const base = (shaderInfo.pos * 8);
                  const color = (shaderInfo.pos * 8 + 1);
                  data[base] = 1.0; // Sichtbarkeit setzen
                  meshes.add(mesh); // das konkrete Mesh speichern
                }
              }

            } else {
                const mesh = shaderEntry.mesh;
                const mat = mesh.material;
                if (mat?.uniforms?.polyMetaTex) {
                  const data = mat.uniforms.polyMetaTex.value.image.data;
                  const base = (shaderInfo.pos * 8);
                  const color = (shaderInfo.pos * 8 + 1);
                  data[base] = 1.0; // Sichtbarkeit setzen
                  meshes.add(mesh); // das konkrete Mesh speichern
                }

              }

          }
        }
      }
      if (this.hoveredRegister?.register){
        for (const body of this.hoveredRegister.register.body) {
          const registerValue = JSON.parse(body.value)
          const shaderInfo = this.getRegisterShaderIndex(
            this.hoveredRegister.wall,
            this.hoveredRegister.dimensionId ?? registerValue.dimensionId,
            registerValue.Reg,
            registerValue.No
          )
          if (shaderInfo == null) {
            continue;
          }
          const shaderEntry = this.wallShaderDic[this.hoveredRegister.wall];
          const mesh = shaderEntry.mesh;
          const mat = mesh.material;
          if (mat?.uniforms?.polyMetaTex) {
            const data = mat.uniforms.polyMetaTex.value.image.data;
            const base = (shaderInfo * 8);
            const color = base + 1
            if (data[color] === 0) {
              data[color] = 0.25
            } else if (data[color] === 1 && data[base] === 1) {
              data[color] = 1.5;
            } else if (data[color] === 1 ) {
              data[color] = 2;
            }
            data[base] = 1; // Sichtbarkeit setzen
            meshes.add(mesh); // das konkrete Mesh speichern
          }
        }
      }


      // jetzt EINmal needsUpdate pro Mesh
      for (const mesh of meshes) {
        const tex = mesh.material.uniforms.polyMetaTex.value;
        tex.needsUpdate = true;
      }

    }
  },

  watch: {
    hoveredAnnoLocked: {
      handler(val){
        this.$emit("setHoveredAnnoLocked", val)
      }
    },
    selectedLocations: {
      handler(val){
        this.$emit("setLocations", val)
      }
    },
    annoPrCount: {
      handler(val){
        this.$emit("setAnnoPrCount", val)
      }
    },
    icoAnnos: {
      handler(val){
        this.$emit("setIcoAnnos", val)
      }
    },
    locationFacets: {
      handler(val){
        this.$emit("setLocationFacets", val)
      }
    },
    showTag: {
      handler(val){
        this.$emit("setShowTag", val)
      }
    },
    hoveredAnno: {
      handler(val){
        this.getTooltipSize()
        this.$emit("setHoveredAnno", val)
      }
    },
    hoveredIcos: {
      handler(val){
        this.$emit("setHoveredIcos", val)
      }
    },
    hoveredRegister: {
      handler(val){
        this.initHighligtAnno()
      }
    },
    selectedDepictions: {
      handler(val) {
        this.initHighligtAnno()
      }

    },
    selectedLocations:{
      handler(val){
        console.log("cave3D, locations set", this.locations);
        this.changedLocationInput()
      },
      deep: true
    },
    relatedDepictions: {
      handler(val){
        this.initIcoTree()
        this.prepLocationAggs()
      },
      deep: true
    },
    camera: {
      handler(val){
        this.switchCamera(val)
      }
    },
    icoSelected: {
      handler(val){
        this.selectDepictionsByicoSelected()
        this.initUpdateAnnoPrCount()
      }
    },
  },
  created () {
    // bewusst NICHT in data(), damit Vue die THREE-Objekte nicht reaktiv macht
    this._lampUniforms = {
      lightMode:     { value: 0 },
      ambientLevel:  { value: 0.015 },   // fast schwarz
      lampPos:       { value: new THREE.Vector3() },
      lampColor:     { value: new THREE.Color(1.0, 0.6, 0.25) },
      lampIntensity: { value: 0 },
      lampRadius:    { value: 3.0 },     // Reichweite in Modell-Einheiten
      sunDir:        { value: new THREE.Vector3(20, 30, 15).normalize() },
      sunColor:      { value: new THREE.Color(1.0, 0.95, 0.85) },
      sunIntensity:  { value: 0.0 }      // Wände bekommen keine Sonne
    }
    this._nightBackup = null
    this._sun = null
    this._lamp = null
    this._lampLight = null
    this._flame = null
  },
  beforeDestroyed () {

  },
  beforeMount:function(){

  },
  mounted() {
    console.log("elemtentID", this.elementID);
    this.checkVR()
    this.controllerModelFactory = new XRControllerModelFactory();
    this.controllerModelFactory.gltfLoader = new GLTFLoader();
    this._zee = new THREE.Vector3(0,0,1)
    this._euler = new THREE.Euler()
    this._q0 = new THREE.Quaternion()
    this._q1 = new THREE.Quaternion(-Math.sqrt(0.5),0,0,Math.sqrt(0.5))
    this._deviceQuat = new THREE.Quaternion()

    document._self = this
    this.interval = 1000 / this.fps
    if (this.item.caveID){
      this.showTree = false
      this.initIcoTree()
      this.initUpdateAnnoPrCount()
    } else {
      this.showTree = false
      this.selectedDepictions.push(this.item.depictionID)
    }
    // this.$refs.locationSearch._self.update = true
    this.cave3DInfForWalls = {}
    this.annotationsByWall = {}

    this.prepareInitCave3dModelViewer();
    this.prepLocationAggs()
  }
}
</script>

<style lang="css" >
  .tooltip {
    color: white !important;
  }
  .scroll-container {
    height: 95vh;
    overflow-y: auto;
  }
  .cave3DControl {
    height: 100%;
  }
  .color-box {
    width: 48px;
    height: 24px;
  }
  .reset-button {
    position: absolute;
    bottom: 20px; /* Abstand von unten */
    right: 20px; /* Abstand von links */
    cursor: pointer;
  }

  .reset-button:hover {
  }
  .tooltipWithPointerEvent{
    pointer-events: all !important;
  }
  .fullscreen-div {
    width: 100vw!important;
    height: 100vh!important;
    position: fixed;
    top: 0;
    left: 0;
    overflow: hidden; /* Kein Scrollen innerhalb des div */
    z-index: 9;
  }
  .filter-bottom-sheet {
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    margin-bottom: 90px;
  }


.sheet-content {
  display: flex;
  flex-direction: column;
  height: 90vh;
}

.sheet-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-bottom: 150px!important;
}

.tree-scroll {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}
.content-wrapper {
  width: 100%;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.overlay-alert {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
}
</style>
